// // import React, { useEffect, useMemo, useRef, useState } from "react";
// // import css from "./order.module.css";
// // import Swal from "sweetalert2";
// // import axios from "axios";
// // import { v4 as uuidv4 } from "uuid";

// // import logoForSlidef from "../../svg/logoForSlidef.svg";
// // import arrowImp from "../../img/arrowDownPick.png";

// // import ProductInOrder from "./productInOrder";
// // import { useCartCalculations } from "./useCartCalculations";

// // import {
// //   getDocs,
// //   getDoc,
// //   doc,
// //   setDoc,
// //   collection,
// //   serverTimestamp,
// //   query,
// //   orderBy,
// //   limit,
// // } from "firebase/firestore";
// // import { db } from "../../firebase";

// // /* ================== NP API ================== */
// // const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

// // async function npGetCitiesSimple(apiKey, q) {
// //   if (!apiKey || !q?.trim()) return [];
// //   const body = {
// //     apiKey,
// //     modelName: "Address",
// //     calledMethod: "getCities",
// //     methodProperties: { FindByString: q },
// //   };
// //   const res = await fetch(NP_API_URL, {
// //     method: "POST",
// //     headers: { "Content-Type": "application/json" },
// //     body: JSON.stringify(body),
// //   });
// //   const json = await res.json();
// //   return Array.isArray(json?.data) ? json.data : [];
// // }

// // async function npGetWarehousesSimple(apiKey, cityRef) {
// //   if (!apiKey || !cityRef) return [];
// //   const body = {
// //     apiKey,
// //     modelName: "AddressGeneral",
// //     calledMethod: "getWarehouses",
// //     methodProperties: { CityRef: cityRef, Page: "1", Limit: "500" },
// //   };
// //   const res = await fetch(NP_API_URL, {
// //     method: "POST",
// //     headers: { "Content-Type": "application/json" },
// //     body: JSON.stringify(body),
// //   });
// //   const json = await res.json();
// //   return Array.isArray(json?.data) ? json.data : [];
// // }

// // /* ================== HELPERS ================== */
// // function splitFio(fio = "") {
// //   const parts = String(fio).trim().split(/\s+/).filter(Boolean);
// //   return {
// //     first: parts[0] || "",
// //     last: parts.slice(1).join(" ") || "",
// //   };
// // }

// // function normalizePhone(s = "") {
// //   return String(s).replace(/\D/g, "");
// // }

// // // ціна як у ProductInOrder (щоб basketOrder не розʼїжджався)
// // function getFinalUnitPrice(p) {
// //   const price = Number(p?.price) || 0;

// //   const hasFixedSale = p?.priceSale && p.priceSale !== "";
// //   const hasSaleDiscount =
// //     p?.saleDiscountPercent && Number(p.saleDiscountPercent) > 0;
// //   const hasActionDiscount =
// //     p?.actionDiscountPercent && Number(p.actionDiscountPercent) > 0;
// //   const hasBundleDiscount =
// //     p?.bundleDiscountPercent && Number(p.bundleDiscountPercent) > 0;

// //   if (hasFixedSale) return Number(p.priceSale) || price;
// //   if (hasSaleDiscount)
// //     return Math.round(price - (price * Number(p.saleDiscountPercent)) / 100);
// //   if (hasActionDiscount)
// //     return Math.round(price - (price * Number(p.actionDiscountPercent)) / 100);
// //   if (hasBundleDiscount)
// //     return Math.round(price - (price * Number(p.bundleDiscountPercent)) / 100);

// //   return price;
// // }

// // /* ================== COMPONENT ================== */
// // const PartnerOrder = ({ setLogin, user, discountInHok, realUser }) => {
// //   const uid = useMemo(() => uuidv4(), []);

// //   /* ===== profile ===== */
// //   const [currentUs, setCurrentUs] = useState(null);

// //   /* ===== loaders ===== */
// //   const [loadingPay, setLoadingPay] = useState(false);

// //   /* ===== buyer main data ===== */
// //   const [name, setName] = useState("");
// //   const [surName, setSurName] = useState("");
// //   const [phone, setPhone] = useState("");

// //   /* ===== receiver data ===== */
// //   const [nameOtr, setNameOtr] = useState("");
// //   const [surNameOtr, setSurNameOtr] = useState("");
// //   const [phoneOtr, setPhoneOtr] = useState("");

// //   /* ===== ui toggles ===== */
// //   const [isNewBuyer, setIsNewBuyer] = useState(true);
// //   const [selectedOption, setSelectedOption] = useState(null); // "Доставка" => Я отримувач
// //   const [whoCust, setWhoCust] = useState(true); // показувати блок отримувача
// //   const [choisDostavka] = useState(true);

// //   /* ===== NP ===== */
// //   const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
// //   const [selectedCountry, setSelectedCountry] = useState("1"); // UA
// //   const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("1"); // NP

// //   const [cityName, setCityName] = useState("");
// //   const [cities, setCities] = useState([]);
// //   const [selectedCity, setSelectedCity] = useState(null);

// //   const [departments, setDepartments] = useState([]);
// //   const [selectedDepartment, setSelectedDepartment] = useState("");
// //   const [ulVisible, setUlVisible] = useState(false);

// //   const cityDebounceRef = useRef(null);

// //   /* ===== business addresses ===== */
// //   const [bizAddresses, setBizAddresses] = useState([]);
// //   const [bizAddrOpen, setBizAddrOpen] = useState(false);
// //   const [bizAddrLoading, setBizAddrLoading] = useState(false);

// //   const isBusinessPartner =
// //     (realUser?.category || currentUs?.category) === "Бізнес-партнер";

// //   /* ===== cart ===== */
// //   const [cartProducts, setCartProducts] = useState([]);

// //   // ✅ промокод не використовуємо
// //   const { totalPrice, newFinValue, applyElefant } = useCartCalculations({
// //     cartProducts,
// //     discountInHok,
// //     currentUser: currentUs,
// //   });

// //   /* ================== LOAD NP KEY ================== */
// //   useEffect(() => {
// //     (async () => {
// //       try {
// //         const snap = await getDoc(doc(db, "novapost", "novaPoshtaData"));
// //         if (snap.exists()) setNovaPoshtaKey(snap.data().key || "");
// //       } catch (e) {
// //         console.error("NP key load error:", e);
// //       }
// //     })();
// //   }, []);

// //   /* ================== LOAD REAL USER (profile) ================== */
// //   useEffect(() => {
// //     const fetchCurrentUser = async () => {
// //       if (!user?.uid) return;

// //       // якщо OrderEntry вже передав realUser — не вантажимо вдруге
// //       if (realUser) {
// //         setCurrentUs(realUser);
// //         return;
// //       }

// //       try {
// //         const snap = await getDoc(doc(db, "users", user.uid));
// //         if (snap.exists()) setCurrentUs({ uid: user.uid, ...snap.data() });
// //       } catch (e) {
// //         console.error("User doc load error:", e);
// //       }
// //     };

// //     fetchCurrentUser();
// //   }, [user?.uid, realUser]);

// //   /* ================== PREFILL FROM PROFILE ================== */
// //   useEffect(() => {
// //     if (!currentUs) return;

// //     if (currentUs.displayName) {
// //       const [first, last] = String(currentUs.displayName).split(" ");
// //       setName(first || "");
// //       setSurName(last || "");
// //     }
// //     setPhone(currentUs.phone || "");

// //     // якщо є стара доставка (може бути корисно як дефолт)
// //     if (currentUs?.deliveryCity?.Ref) {
// //       setSelectedCity(currentUs.deliveryCity);
// //       setCityName(currentUs.deliveryCity?.Description || "");
// //       setSelectedDepartment(currentUs.deliveryDepartment || "");
// //     }
// //   }, [currentUs]);

// //   /* ================== LOAD BUSINESS ADDRESSES ================== */
// //   useEffect(() => {
// //     const loadBizAddresses = async () => {
// //       if (!user?.uid) return;
// //       if (!isBusinessPartner) return;

// //       setBizAddrLoading(true);
// //       try {
// //         const ref = collection(db, `users/${user.uid}/deliveryAddresses`);
// //         const qx = query(ref, orderBy("createdAt", "desc"), limit(50));
// //         const snap = await getDocs(qx);
// //         const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
// //         setBizAddresses(list);
// //       } catch (e) {
// //         console.error("Помилка завантаження бізнес-адрес:", e);
// //         setBizAddresses([]);
// //       } finally {
// //         setBizAddrLoading(false);
// //       }
// //     };

// //     loadBizAddresses();
// //   }, [user?.uid, isBusinessPartner]);

// //   const applyBizAddress = (addr) => {
// //     if (!addr) return;

// //     // Вмикаємо блок отримувача, вимикаємо "Я отримувач"
// //     setSelectedOption(null);
// //     setWhoCust(true);

// //     const { first, last } = splitFio(addr.fio || "");
// //     setNameOtr(first);
// //     setSurNameOtr(last);
// //     setPhoneOtr(String(addr.phone || ""));

// //     const city = String(addr.city || "").trim();
// //     const area = String(addr.area || "").trim();
// //     const dept = String(addr.npWarehouse || "").trim();

// //     setCityName(city);
// //     setSelectedDepartment(dept);
// //     setUlVisible(false);

// //     if (addr.cityRef) {
// //       setSelectedCity({
// //         Ref: addr.cityRef,
// //         Description: city,
// //         AreaDescription: area,
// //       });
// //     } else {
// //       setSelectedCity(null);
// //     }

// //     Swal.fire({
// //       icon: "success",
// //       title: "Адресу підставлено",
// //       timer: 900,
// //       showConfirmButton: false,
// //     });
// //   };

// //   /* ================== LOAD WAREHOUSES ================== */
// //   useEffect(() => {
// //     (async () => {
// //       if (!novaPoshtaKey || !selectedCity?.Ref) {
// //         setDepartments([]);
// //         return;
// //       }
// //       const list = await npGetWarehousesSimple(novaPoshtaKey, selectedCity.Ref);
// //       setDepartments(list);
// //     })();
// //   }, [novaPoshtaKey, selectedCity?.Ref]);

// //   /* ================== CITY SEARCH (з дебаунсом) ================== */
// //   const handleCityInputChange = (e) => {
// //     const val = e.target.value;
// //     setCityName(val);
// //     setUlVisible(true);
// //     setSelectedCity(null);
// //     setSelectedDepartment("");

// //     if (cityDebounceRef.current) clearTimeout(cityDebounceRef.current);

// //     cityDebounceRef.current = setTimeout(async () => {
// //       if (!novaPoshtaKey) return;
// //       const list = await npGetCitiesSimple(novaPoshtaKey, val);
// //       setCities(list || []);
// //     }, 250);
// //   };

// //   const handleCityClick = (city) => {
// //     setSelectedCity(city);
// //     setCityName(city?.Description || "");
// //     setUlVisible(false);
// //     setSelectedDepartment("");
// //   };

// //   /* ================== CART LOAD ================== */
// //   useEffect(() => {
// //     const fetchProducts = async () => {
// //       const cartLocal = JSON.parse(localStorage.getItem("cart") || "[]"); // [{uid, quantity}]
// //       if (!Array.isArray(cartLocal) || cartLocal.length === 0) {
// //         setCartProducts([]);
// //         return;
// //       }

// //       const [productsSnap, bundlesSnap, actionsSnap, salesSnap] =
// //         await Promise.all([
// //           getDocs(collection(db, "product")),
// //           getDocs(collection(db, "bundles")),
// //           getDocs(collection(db, "actions")),
// //           getDocs(collection(db, "sales")),
// //         ]);

// //       const productsList = productsSnap.docs.map((d) => ({
// //         id: d.id,
// //         ...d.data(),
// //       }));
// //       const bundles = bundlesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
// //       const actions = actionsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
// //       const sales = salesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

// //       const now = new Date();

// //       const withFlags = cartLocal
// //         .map((ci) => {
// //           const product = productsList.find((p) => p.id === ci.uid);
// //           if (!product) return null;

// //           // actions
// //           let actionDiscount = null;
// //           const matchedAction = actions.find((a) => {
// //             const start = a.startDate ? new Date(a.startDate) : null;
// //             const end = a.endDate ? new Date(a.endDate) : null;
// //             if (end && now > end) return false;
// //             if (start && now < start) return false;

// //             const matchProduct = a.appliesTo?.products?.includes(product.id);

// //             const productSeries = Array.isArray(product.seria)
// //               ? product.seria
// //               : typeof product.seria === "string" && product.seria !== ""
// //                 ? [product.seria]
// //                 : [];
// //             const matchSeries = productSeries.some((ser) =>
// //               a.appliesTo?.series?.includes(ser),
// //             );

// //             const productAuthors = Array.isArray(product.textAutor)
// //               ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
// //               : typeof product.textAutor === "string" &&
// //                   product.textAutor !== ""
// //                 ? [product.textAutor.split(" ")[0].trim()]
// //                 : [];
// //             const actionAuthors = Array.isArray(a.appliesTo?.authors)
// //               ? a.appliesTo.authors.map((x) => (x || "").split(" ")[0].trim())
// //               : [];
// //             const matchAuthor = productAuthors.some((x) =>
// //               actionAuthors.includes(x),
// //             );

// //             return matchProduct || matchSeries || matchAuthor;
// //           });

// //           if (matchedAction) actionDiscount = matchedAction.discountPercent;

// //           // sales
// //           let saleDiscount = null;
// //           const matchedSale = sales.find((s) => {
// //             const start = s.startDate ? new Date(s.startDate) : null;
// //             const end = s.endDate ? new Date(s.endDate) : null;
// //             if (end && now > end) return false;
// //             if (start && now < start) return false;

// //             const applies = s.appliesTo || {};
// //             const matchProduct =
// //               Array.isArray(applies.products) &&
// //               applies.products.includes(product.id);

// //             const productSeries =
// //               Array.isArray(product.seria) && product.seria.length
// //                 ? product.seria
// //                 : typeof product.seria === "string" && product.seria !== ""
// //                   ? [product.seria]
// //                   : Array.isArray(product.series) && product.series.length
// //                     ? product.series
// //                     : typeof product.series === "string" &&
// //                         product.series !== ""
// //                       ? [product.series]
// //                       : [];

// //             const matchSeries =
// //               Array.isArray(applies.series) &&
// //               productSeries.some((ser) => applies.series.includes(ser));

// //             const productAuthors = Array.isArray(product.textAutor)
// //               ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
// //               : typeof product.textAutor === "string" &&
// //                   product.textAutor !== ""
// //                 ? [product.textAutor.split(" ")[0].trim()]
// //                 : [];
// //             const saleAuthors = Array.isArray(applies.authors)
// //               ? applies.authors.map((x) => (x || "").split(" ")[0].trim())
// //               : [];
// //             const matchAuthor = productAuthors.some((x) =>
// //               saleAuthors.includes(x),
// //             );

// //             return matchProduct || matchSeries || matchAuthor;
// //           });

// //           if (matchedSale)
// //             saleDiscount = Number(matchedSale.discountPercent) || 0;

// //           return {
// //             ...product,
// //             uid: ci.uid,
// //             quantity: ci.quantity,
// //             actionDiscountPercent: actionDiscount,
// //             saleDiscountPercent: saleDiscount,
// //           };
// //         })
// //         .filter(Boolean);

// //       // bundles
// //       bundles.forEach((b) => {
// //         const ids = (b.products || []).map((p) => (p.productId || "").trim());
// //         const inCart = withFlags.filter((p) =>
// //           ids.includes((p.id || "").trim()),
// //         );
// //         if (inCart.length >= (b.products || []).length) {
// //           inCart.forEach((item) => {
// //             const matchBundleItem = (b.products || []).find(
// //               (p) => (p.productId || "").trim() === (item.id || "").trim(),
// //             );
// //             if (matchBundleItem?.discount)
// //               item.actionDiscountPercent = matchBundleItem.discount;
// //           });
// //         }
// //       });

// //       setCartProducts(withFlags);
// //     };

// //     fetchProducts();
// //   }, []);

// //   const writeCartToLS = (items) => {
// //     // items: [{uid, quantity}]
// //     localStorage.setItem("cart", JSON.stringify(items));
// //   };

// //   const handleQuantityChange = (uidItem, quantity) => {
// //     setCartProducts((prev) =>
// //       (prev || []).map((p) => (p.uid === uidItem ? { ...p, quantity } : p)),
// //     );

// //     const cart = JSON.parse(localStorage.getItem("cart") || "[]");
// //     const next = Array.isArray(cart)
// //       ? cart.map((x) => (x.uid === uidItem ? { ...x, quantity } : x))
// //       : [];
// //     writeCartToLS(next);
// //   };

// //   const removeProduct = (uidItem) => {
// //     setCartProducts((prev) => (prev || []).filter((p) => p.uid !== uidItem));

// //     const cart = JSON.parse(localStorage.getItem("cart") || "[]");
// //     const next = Array.isArray(cart)
// //       ? cart.filter((x) => x.uid !== uidItem)
// //       : [];
// //     writeCartToLS(next);
// //   };

// //   /* ================== ELEPHANTS ================== */
// //   const handleApplyelefant = async () => {
// //     if (!currentUs || !currentUs.elefant || parseInt(currentUs.elefant) === 0) {
// //       Swal.fire({
// //         icon: "info",
// //         title: "Увага",
// //         text: "У вас немає доступних слонів для списання.",
// //       });
// //       return;
// //     }

// //     const elephantsUsed = await applyElefant(async (uidUpdate) => {
// //       const userDocRef = doc(db, "users", uidUpdate);
// //       await setDoc(userDocRef, { elefant: "0" }, { merge: true });
// //       setCurrentUs((p) => ({ ...(p || {}), elefant: "0" }));
// //     });

// //     if (elephantsUsed === false) {
// //       Swal.fire({ icon: "info", title: "Увага", text: "Слонів немає." });
// //     } else {
// //       Swal.fire({
// //         icon: "success",
// //         title: "Слони застосовані!",
// //         text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
// //       });
// //     }
// //   };

// //   /* ================== VALIDATION ================== */
// //   const validateForm = () => {
// //     if (
// //       !(name || "").trim() ||
// //       !(surName || "").trim() ||
// //       !(phone || "").trim()
// //     ) {
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Заповніть: Ім'я, Прізвище, Телефон.",
// //       });
// //       return false;
// //     }

// //     // якщо НЕ "Я отримувач" — тоді потрібні дані отримувача
// //     if (
// //       !selectedOption &&
// //       (!(nameOtr || "").trim() ||
// //         !(surNameOtr || "").trim() ||
// //         !(phoneOtr || "").trim())
// //     ) {
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Заповніть дані отримувача.",
// //       });
// //       return false;
// //     }

// //     if (!(cityName || "").trim()) {
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Введіть місто доставки.",
// //       });
// //       return false;
// //     }

// //     if (selectedDeliveryMethod === "1" && !(selectedDepartment || "").trim()) {
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Виберіть відділення Нової пошти.",
// //       });
// //       return false;
// //     }

// //     return true;
// //   };

// //   /* ================== PAY ================== */
// //   const payParam = async (e) => {
// //     e.preventDefault();
// //     if (!validateForm()) return;

// //     try {
// //       setLoadingPay(true);

// //       const json = JSON.stringify(cartProducts || []);
// //       const us = user ? user.uid : "";

// //       const orderPayload = {
// //         uid,
// //         choice: json,
// //         totalPrice, // як було (для аналітики)
// //         finishPrice: newFinValue, // ✅ реальна сума до оплати
// //         phone,
// //         name,
// //         surName,
// //         discount: discountInHok,

// //         nameOtr,
// //         surNameOtr,
// //         phoneOtr,

// //         isNewBuyer,
// //         cityName,
// //         selectedDepartment,

// //         pay: "card",
// //         paymentStatus: "false",
// //         user: us,
// //         status: "Очікує підтвердження",
// //         createdAt: serverTimestamp(),
// //         userCategory: "Бізнес-партнер",
// //       };

// //       await setDoc(doc(db, "orders", uid), orderPayload);

// //       const payload = {
// //         id: uid,
// //         amount: Math.round(Number(newFinValue) * 100), // ✅ важливо
// //         ccy: 980,
// //         merchantPaymInfo: {
// //           reference: "84d0070ee4e44667b31371d8f8813947",
// //           destination: "Оплата товарів час майстрів",
// //           comment: "Оплата товарів час майстрів",
// //           customerEmails: [],
// //           basketOrder: (cartProducts || []).map((p) => ({
// //             name: p.bookName,
// //             qty: p.quantity,
// //             sum: getFinalUnitPrice(p) * 100, // ✅ одинична ціна в копійках
// //             icon: p.imageList?.[0],
// //             unit: "шт.",
// //             code: p.ISBN,
// //           })),
// //         },
// //         webHookUrl: "https://chas-maistriv.com.ua/api/webhook",
// //         paymentType: "debit",
// //         saveCardData: {
// //           saveCard: true,
// //           walletId: "69f780d841a0434aa535b08821f4822c",
// //         },
// //         redirectUrl: "https://chas-maistriv.com.ua/",
// //         initiationKind: "merchant",
// //         tds: true,
// //         newProduct: orderPayload,
// //       };

// //       const resp = await axios.post(
// //         "https://chas-maistriv.com.ua/api/create-payment",
// //         payload,
// //         { headers: { "Content-Type": "application/json" } },
// //       );

// //       if (resp?.data && resp?.statusText === "OK") {
// //         localStorage.removeItem("cart");
// //         window.location.href = resp.data.pageUrl;
// //       } else {
// //         throw new Error("Помилка створення платежу");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Не вдалося створити оплату. Спробуйте пізніше.",
// //       });
// //       setLoadingPay(false);
// //     }
// //   };

// //   /* ================== UI HANDLERS ================== */
// //   const handleNewBuyerClick = () => setIsNewBuyer(true);
// //   const handleAlwaysBuyerClick = () => setIsNewBuyer(false);

// //   const handleOptionClick = (opt) => {
// //     if (selectedOption === opt) {
// //       setSelectedOption(null);
// //       setWhoCust(true);
// //     } else {
// //       setSelectedOption(opt);
// //       setWhoCust(false);
// //     }
// //   };

// //   /* ================== RENDER ================== */
// //   return (
// //     <>
// //       <div className={css.blueHeaderOrder}>
// //         <div className={css.blueHeaderOrderEnter}>
// //           <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
// //         </div>
// //       </div>

// //       <div className={css.wrapCenterOrder}>
// //         <div className={css.wrapCenterOrderSmall}>
// //           <div className={css.firstBlockWrap}>
// //             {!currentUs && (
// //               <div className={css.newUserOrNoWrap}>
// //                 <div
// //                   className={`${css.newAlwaysBayer} ${isNewBuyer ? css.newBayer : ""}`}
// //                   onClick={handleNewBuyerClick}
// //                 >
// //                   Я новий покупець
// //                 </div>
// //                 <div
// //                   className={`${css.newAlwaysBayer} ${!isNewBuyer ? css.newBayer : ""}`}
// //                   onClick={handleAlwaysBuyerClick}
// //                 >
// //                   Я постійний покупець
// //                 </div>
// //               </div>
// //             )}

// //             {!user && (
// //               <p className={css.registerToOrder}>
// //                 <span
// //                   onClick={() => setLogin(true)}
// //                   className={css.registerToOrderSpan}
// //                 >
// //                   ЗАРЕЄСТРУВАТИСЬ
// //                 </span>{" "}
// //                 для відслідковування замовлення
// //               </p>
// //             )}

// //             <p className={css.labelMi}>Особисті дані</p>
// //             <div className={css.wrapUserData}>
// //               <input
// //                 className={css.inputBig}
// //                 type="text"
// //                 placeholder="Ім'я"
// //                 value={name}
// //                 onChange={(e) => setName(e.target.value)}
// //               />
// //               <input
// //                 className={css.inputBig}
// //                 type="text"
// //                 placeholder="Прізвище"
// //                 value={surName}
// //                 onChange={(e) => setSurName(e.target.value)}
// //               />
// //               <input
// //                 className={css.inputBig}
// //                 type="tel"
// //                 placeholder="Телефон"
// //                 value={phone}
// //                 onChange={(e) => setPhone(e.target.value)}
// //                 required
// //               />
// //             </div>

// //             <div className={css.deliveryChoisWrap}>
// //               <div
// //                 className={css.choisWrap}
// //                 onClick={() => handleOptionClick("Доставка")}
// //               >
// //                 <div className={css.choisWi}>
// //                   {selectedOption === "Доставка" && <div className={css.wi} />}
// //                 </div>
// //                 <p className={css.choisP}>Я отримувач</p>
// //               </div>
// //             </div>

// //             {choisDostavka && (
// //               <div className={css.wrapUserData}>
// //                 {/* ====== BUSINESS SAVED ADDRESSES ====== */}
// //                 {isBusinessPartner && (
// //                   <div style={{ marginBottom: 12, width: "100%" }}>
// //                     <div
// //                       style={{
// //                         display: "flex",
// //                         justifyContent: "flex-start",
// //                         gap: 40,
// //                       }}
// //                     >
// //                       <p className={css.choisP}>Збережені адреси</p>

// //                       <button
// //                         type="button"
// //                         onClick={() => setBizAddrOpen((v) => !v)}
// //                         style={{
// //                           padding: "8px 12px",
// //                           borderRadius: 0,
// //                           border: "3px solid #3fac8c",
// //                           background: "#fff",
// //                           cursor: "pointer",
// //                           fontWeight: 600,
// //                           color: "#758391",
// //                         }}
// //                         disabled={bizAddrLoading}
// //                       >
// //                         {bizAddrLoading
// //                           ? "Завантаження…"
// //                           : bizAddrOpen
// //                             ? "Закрити"
// //                             : "Вибрати адресу"}
// //                       </button>
// //                     </div>

// //                     {bizAddrOpen && (
// //                       <div
// //                         style={{
// //                           marginTop: 10,
// //                           border: "1px solid #eee",
// //                           borderRadius: 12,
// //                           overflow: "hidden",
// //                           maxHeight: 260,
// //                           overflowY: "auto",
// //                           background: "#fff",
// //                         }}
// //                       >
// //                         {bizAddresses.length === 0 ? (
// //                           <div style={{ padding: 10, color: "#777" }}>
// //                             Адрес немає
// //                           </div>
// //                         ) : (
// //                           bizAddresses.map((a) => (
// //                             <div
// //                               key={a.id}
// //                               style={{
// //                                 display: "grid",
// //                                 gridTemplateColumns:
// //                                   "1.2fr 0.9fr 1.2fr 1.8fr auto",
// //                                 gap: 10,
// //                                 alignItems: "center",
// //                                 padding: 10,
// //                                 borderTop: "1px solid #f2f2f2",
// //                                 fontSize: 14,
// //                               }}
// //                             >
// //                               <div>{a.fio}</div>
// //                               <div>{a.phone}</div>
// //                               <div>
// //                                 {a.city}
// //                                 {a.area ? `, ${a.area}` : ""}
// //                               </div>
// //                               <div>{a.npWarehouse}</div>

// //                               <button
// //                                 type="button"
// //                                 onClick={() => applyBizAddress(a)}
// //                                 style={{
// //                                   padding: "8px 12px",
// //                                   borderRadius: 0,
// //                                   border: "3px solid #3fac8c",
// //                                   background: "#fff",
// //                                   cursor: "pointer",
// //                                   fontWeight: 600,
// //                                   color: "#758391",
// //                                 }}
// //                               >
// //                                 Використати
// //                               </button>
// //                             </div>
// //                           ))
// //                         )}
// //                       </div>
// //                     )}
// //                   </div>
// //                 )}

// //                 <div className={css.chousBooksSelect}>
// //                   <select
// //                     className={css.customSelect}
// //                     value={selectedCountry}
// //                     onChange={(e) => setSelectedCountry(e.target.value)}
// //                   >
// //                     <option className={css.customOpin} value="1">
// //                       Україна
// //                     </option>
// //                   </select>
// //                   <img
// //                     src={arrowImp}
// //                     className={css.customArrowSelect}
// //                     alt="Arrow"
// //                   />
// //                 </div>

// //                 {/* Місто */}
// //                 <div className={css.chousBooksSelect}>
// //                   <input
// //                     className={css.inputSmallWrap}
// //                     type="text"
// //                     value={cityName}
// //                     onChange={handleCityInputChange}
// //                     placeholder="Місто"
// //                     onFocus={() => setUlVisible(true)}
// //                   />
// //                   {ulVisible && Array.isArray(cities) && cities.length > 0 && (
// //                     <ul className={css.ulWrapBigCity}>
// //                       {cities.map((city, i) => (
// //                         <li
// //                           onClick={() => handleCityClick(city)}
// //                           key={`${city.Ref || i}-${i}`}
// //                           className={css.liInListSitu}
// //                         >
// //                           {city.SettlementTypeDescription
// //                             ? `${city.SettlementTypeDescription}, `
// //                             : ""}
// //                           {city.Description}
// //                           {city.AreaDescription
// //                             ? `, ${city.AreaDescription}`
// //                             : ""}
// //                         </li>
// //                       ))}
// //                     </ul>
// //                   )}
// //                   <img
// //                     src={arrowImp}
// //                     className={css.customArrowSelect}
// //                     alt="Arrow"
// //                   />
// //                 </div>

// //                 {/* Метод доставки */}
// //                 <div className={css.chousBooksSelectBig}>
// //                   <select
// //                     className={css.customSelect}
// //                     value={selectedDeliveryMethod}
// //                     onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
// //                   >
// //                     <option className={css.customOpin} value="1">
// //                       Нова пошта
// //                     </option>
// //                   </select>
// //                   <img
// //                     src={arrowImp}
// //                     className={css.customArrowSelect}
// //                     alt="Arrow"
// //                   />
// //                 </div>

// //                 {/* Відділення */}
// //                 <div className={css.chousBooksSelectBig}>
// //                   <select
// //                     className={css.customSelect}
// //                     value={selectedDepartment}
// //                     onChange={(e) => setSelectedDepartment(e.target.value)}
// //                     disabled={
// //                       !selectedCity?.Ref || selectedDeliveryMethod !== "1"
// //                     }
// //                   >
// //                     {selectedDepartment ? (
// //                       <option value={selectedDepartment}>
// //                         {selectedDepartment}
// //                       </option>
// //                     ) : (
// //                       <option value="">Оберіть відділення</option>
// //                     )}

// //                     {Array.isArray(departments) && departments.length > 0 ? (
// //                       departments.map((d, idx) => (
// //                         <option
// //                           key={`${d.Ref || idx}`}
// //                           value={d?.Description || ""}
// //                         >
// //                           {d?.Description || "Відділення"}
// //                         </option>
// //                       ))
// //                     ) : (
// //                       <option value="" disabled>
// //                         Відділень не знайдено
// //                       </option>
// //                     )}
// //                   </select>

// //                   <img
// //                     src={arrowImp}
// //                     className={css.customArrowSelect}
// //                     alt="Arrow"
// //                   />
// //                 </div>
// //               </div>
// //             )}

// //             {whoCust && (
// //               <>
// //                 <p className={css.labelMi}>Контактні дані отримувача</p>
// //                 <div className={css.wrapUserData}>
// //                   <input
// //                     className={css.inputBig}
// //                     type="text"
// //                     placeholder="Ім'я"
// //                     value={nameOtr}
// //                     onChange={(e) => setNameOtr(e.target.value)}
// //                   />
// //                   <input
// //                     className={css.inputBig}
// //                     type="text"
// //                     placeholder="Прізвище"
// //                     value={surNameOtr}
// //                     onChange={(e) => setSurNameOtr(e.target.value)}
// //                   />
// //                   <input
// //                     className={css.inputBig}
// //                     type="tel"
// //                     placeholder="Телефон"
// //                     value={phoneOtr}
// //                     onChange={(e) => setPhoneOtr(e.target.value)}
// //                     required
// //                   />
// //                 </div>
// //               </>
// //             )}

// //             <button
// //               type="submit"
// //               className={css.orderConfirmation}
// //               onClick={payParam}
// //             >
// //               Оформити замовлення
// //             </button>
// //           </div>

// //           <div className={css.wrapProdForOrder}>
// //             {cartProducts?.map((el, i) => (
// //               <ProductInOrder
// //                 key={i}
// //                 el={el}
// //                 removeProduct={removeProduct}
// //                 handleQuantityChange={handleQuantityChange}
// //               />
// //             ))}

// //             <div className={css.lineWrap} />
// //             <p className={css.sumOrder}>Всього: {totalPrice} грн</p>
// //             <p className={css.sumOrder}>Знижка: {discountInHok} %</p>

// //             {/* слони лишив як було */}
// //             <div className={css.discountWrapOrder}>
// //               <p className={css.slonuInL}>
// //                 Ви можете використати Ваші слони. Загальна кількість слонів{" "}
// //                 <strong>{currentUs && currentUs.elefant}</strong>
// //               </p>
// //               <div className={css.promoButton} onClick={handleApplyelefant}>
// //                 Застосувати
// //               </div>
// //             </div>

// //             {/* ❌ ПРОМОКОД тут відсутній */}
// //             <p className={css.sum}>Сума: {newFinValue} грн</p>
// //           </div>
// //         </div>
// //       </div>

// //       {loadingPay && (
// //         <div className={css.spinerWrap}>
// //           <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default PartnerOrder;
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import css from "./order.module.css";
// import Swal from "sweetalert2";
// import { v4 as uuidv4 } from "uuid";

// import logoForSlidef from "../../svg/logoForSlidef.svg";
// import arrowImp from "../../img/arrowDownPick.png";

// import { startInvoiceCreate, startLiqPayCheckout } from "./paymentApi";
// import { redirectToLiqPay } from "./liqpayRedirect";

// import ProductInOrder from "./productInOrder";
// import { useCartCalculations } from "./useCartCalculations";

// import {
//   getDocs,
//   getDoc,
//   doc,
//   setDoc,
//   collection,
//   serverTimestamp,
//   query,
//   orderBy,
//   limit,
// } from "firebase/firestore";
// import { db } from "../../firebase";

// /* ================== NP API ================== */
// const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

// async function npGetCitiesSimple(apiKey, q) {
//   if (!apiKey || !q?.trim()) return [];
//   const body = {
//     apiKey,
//     modelName: "Address",
//     calledMethod: "getCities",
//     methodProperties: { FindByString: q },
//   };
//   const res = await fetch(NP_API_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(body),
//   });
//   const json = await res.json();
//   return Array.isArray(json?.data) ? json.data : [];
// }

// async function npGetWarehousesSimple(apiKey, cityRef) {
//   if (!apiKey || !cityRef) return [];
//   const body = {
//     apiKey,
//     modelName: "AddressGeneral",
//     calledMethod: "getWarehouses",
//     methodProperties: { CityRef: cityRef, Page: "1", Limit: "500" },
//   };
//   const res = await fetch(NP_API_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(body),
//   });
//   const json = await res.json();
//   return Array.isArray(json?.data) ? json.data : [];
// }

// /* ================== HELPERS ================== */
// function splitFio(fio = "") {
//   const parts = String(fio).trim().split(/\s+/).filter(Boolean);
//   return { first: parts[0] || "", last: parts.slice(1).join(" ") || "" };
// }

// function getFinalUnitPrice(p) {
//   const price = Number(p?.price) || 0;

//   const hasFixedSale = p?.priceSale && p.priceSale !== "";
//   const hasSaleDiscount =
//     p?.saleDiscountPercent && Number(p.saleDiscountPercent) > 0;
//   const hasActionDiscount =
//     p?.actionDiscountPercent && Number(p.actionDiscountPercent) > 0;
//   const hasBundleDiscount =
//     p?.bundleDiscountPercent && Number(p.bundleDiscountPercent) > 0;

//   if (hasFixedSale) return Number(p.priceSale) || price;
//   if (hasSaleDiscount)
//     return Math.round(price - (price * Number(p.saleDiscountPercent)) / 100);
//   if (hasActionDiscount)
//     return Math.round(price - (price * Number(p.actionDiscountPercent)) / 100);
//   if (hasBundleDiscount)
//     return Math.round(price - (price * Number(p.bundleDiscountPercent)) / 100);

//   return price;
// }

// function getInitialPayMethod(userDoc) {
//   if (!userDoc) return "card";
//   if (userDoc.payByInvoice === true) return "invoice";

//   const raw =
//     userDoc.preferredPaymentMethod ??
//     userDoc.paymentMethod ??
//     userDoc.payMethod ??
//     userDoc.pay ??
//     "";

//   const v = String(raw).toLowerCase().trim();

//   if (v.includes("рах") || v.includes("invoice") || v === "2") return "invoice";
//   if (v.includes("карт") || v.includes("card") || v === "1") return "card";

//   return "card";
// }

// /* ================== COMPONENT ================== */
// const PartnerOrder = ({ setLogin, user, discountInHok, realUser }) => {
//   const uid = useMemo(() => uuidv4(), []);

//   /* ===== profile ===== */
//   const [currentUs, setCurrentUs] = useState(null);

//   /* ===== loaders ===== */
//   const [loadingPay, setLoadingPay] = useState(false);

//   /* ===== buyer main data ===== */
//   const [name, setName] = useState("");
//   const [surName, setSurName] = useState("");
//   const [phone, setPhone] = useState("");

//   /* ===== receiver data ===== */
//   const [nameOtr, setNameOtr] = useState("");
//   const [surNameOtr, setSurNameOtr] = useState("");
//   const [phoneOtr, setPhoneOtr] = useState("");

//   /* ===== ui toggles ===== */
//   const [isNewBuyer, setIsNewBuyer] = useState(true);
//   const [selectedOption, setSelectedOption] = useState(null); // "Доставка" => Я отримувач
//   const [whoCust, setWhoCust] = useState(true);
//   const [choisDostavka] = useState(true);

//   /* ===== PAYMENT METHOD ===== */
//   const [paymentMethod, setPaymentMethod] = useState("card"); // "invoice" | "card"
//   const paymentInitRef = useRef(false);

//   /* ===== NP ===== */
//   const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
//   const [selectedCountry, setSelectedCountry] = useState("1"); // UA
//   const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("1"); // NP

//   const [cityName, setCityName] = useState("");
//   const [cities, setCities] = useState([]);
//   const [selectedCity, setSelectedCity] = useState(null);

//   const [departments, setDepartments] = useState([]);
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [ulVisible, setUlVisible] = useState(false);

//   const cityDebounceRef = useRef(null);

//   /* ===== business addresses ===== */
//   const [bizAddresses, setBizAddresses] = useState([]);
//   const [bizAddrOpen, setBizAddrOpen] = useState(false);
//   const [bizAddrLoading, setBizAddrLoading] = useState(false);

//   const isBusinessPartner =
//     (realUser?.category || currentUs?.category) === "Бізнес-партнер";

//   /* ===== cart ===== */
//   const [cartProducts, setCartProducts] = useState([]);

//   const { totalPrice, newFinValue, applyElefant } = useCartCalculations({
//     cartProducts,
//     discountInHok,
//     currentUser: currentUs,
//   });

//   /* ================== LOAD NP KEY ================== */
//   useEffect(() => {
//     (async () => {
//       try {
//         const snap = await getDoc(doc(db, "novapost", "novaPoshtaData"));
//         if (snap.exists()) setNovaPoshtaKey(snap.data().key || "");
//       } catch (e) {
//         console.error("NP key load error:", e);
//       }
//     })();
//   }, []);

//   /* ================== LOAD REAL USER (profile) ================== */
//   useEffect(() => {
//     const fetchCurrentUser = async () => {
//       if (!user?.uid) return;

//       if (realUser) {
//         setCurrentUs(realUser);
//         return;
//       }

//       try {
//         const snap = await getDoc(doc(db, "users", user.uid));
//         if (snap.exists()) setCurrentUs({ uid: user.uid, ...snap.data() });
//       } catch (e) {
//         console.error("User doc load error:", e);
//       }
//     };

//     fetchCurrentUser();
//   }, [user?.uid, realUser]);

//   /* ================== PREFILL FROM PROFILE ================== */
//   useEffect(() => {
//     if (!currentUs) return;

//     if (currentUs.displayName) {
//       const [first, last] = String(currentUs.displayName).split(" ");
//       setName(first || "");
//       setSurName(last || "");
//     }
//     setPhone(currentUs.phone || "");

//     if (currentUs?.deliveryCity?.Ref) {
//       setSelectedCity(currentUs.deliveryCity);
//       setCityName(currentUs.deliveryCity?.Description || "");
//       setSelectedDepartment(currentUs.deliveryDepartment || "");
//     }

//     if (!paymentInitRef.current) {
//       setPaymentMethod(getInitialPayMethod(currentUs));
//       paymentInitRef.current = true;
//     }
//   }, [currentUs]);

//   /* ===== payment method click ===== */
//   const handlePaymentMethodClick = (method) => {
//     setPaymentMethod(method);
//   };

//   /* ================== LOAD BUSINESS ADDRESSES ================== */
//   useEffect(() => {
//     const loadBizAddresses = async () => {
//       if (!user?.uid) return;
//       if (!isBusinessPartner) return;

//       setBizAddrLoading(true);
//       try {
//         const ref = collection(db, `users/${user.uid}/deliveryAddresses`);
//         const qx = query(ref, orderBy("createdAt", "desc"), limit(50));
//         const snap = await getDocs(qx);
//         const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//         setBizAddresses(list);
//       } catch (e) {
//         console.error("Помилка завантаження бізнес-адрес:", e);
//         setBizAddresses([]);
//       } finally {
//         setBizAddrLoading(false);
//       }
//     };

//     loadBizAddresses();
//   }, [user?.uid, isBusinessPartner]);

//   const applyBizAddress = (addr) => {
//     if (!addr) return;

//     setSelectedOption(null);
//     setWhoCust(true);

//     const { first, last } = splitFio(addr.fio || "");
//     setNameOtr(first);
//     setSurNameOtr(last);
//     setPhoneOtr(String(addr.phone || ""));

//     const city = String(addr.city || "").trim();
//     const area = String(addr.area || "").trim();
//     const dept = String(addr.npWarehouse || "").trim();

//     setCityName(city);
//     setSelectedDepartment(dept);
//     setUlVisible(false);

//     if (addr.cityRef) {
//       setSelectedCity({
//         Ref: addr.cityRef,
//         Description: city,
//         AreaDescription: area,
//       });
//     } else {
//       setSelectedCity(null);
//     }

//     Swal.fire({
//       icon: "success",
//       title: "Адресу підставлено",
//       timer: 900,
//       showConfirmButton: false,
//     });
//   };

//   /* ================== LOAD WAREHOUSES ================== */
//   useEffect(() => {
//     (async () => {
//       if (!novaPoshtaKey || !selectedCity?.Ref) {
//         setDepartments([]);
//         return;
//       }
//       const list = await npGetWarehousesSimple(novaPoshtaKey, selectedCity.Ref);
//       setDepartments(list);
//     })();
//   }, [novaPoshtaKey, selectedCity?.Ref]);

//   /* ================== CITY SEARCH (debounce) ================== */
//   const handleCityInputChange = (e) => {
//     const val = e.target.value;
//     setCityName(val);
//     setUlVisible(true);
//     setSelectedCity(null);
//     setSelectedDepartment("");

//     if (cityDebounceRef.current) clearTimeout(cityDebounceRef.current);

//     cityDebounceRef.current = setTimeout(async () => {
//       if (!novaPoshtaKey) return;
//       const list = await npGetCitiesSimple(novaPoshtaKey, val);
//       setCities(list || []);
//     }, 250);
//   };

//   const handleCityClick = (city) => {
//     setSelectedCity(city);
//     setCityName(city?.Description || "");
//     setUlVisible(false);
//     setSelectedDepartment("");
//   };

//   /* ================== CART LOAD ================== */
//   useEffect(() => {
//     const fetchProducts = async () => {
//       const cartLocal = JSON.parse(localStorage.getItem("cart") || "[]");
//       if (!Array.isArray(cartLocal) || cartLocal.length === 0) {
//         setCartProducts([]);
//         return;
//       }

//       const [productsSnap, bundlesSnap, actionsSnap, salesSnap] =
//         await Promise.all([
//           getDocs(collection(db, "product")),
//           getDocs(collection(db, "bundles")),
//           getDocs(collection(db, "actions")),
//           getDocs(collection(db, "sales")),
//         ]);

//       const productsList = productsSnap.docs.map((d) => ({
//         id: d.id,
//         ...d.data(),
//       }));
//       const bundles = bundlesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       const actions = actionsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       const sales = salesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

//       const now = new Date();

//       const withFlags = cartLocal
//         .map((ci) => {
//           const product = productsList.find((p) => p.id === ci.uid);
//           if (!product) return null;

//           let actionDiscount = null;
//           const matchedAction = actions.find((a) => {
//             const start = a.startDate ? new Date(a.startDate) : null;
//             const end = a.endDate ? new Date(a.endDate) : null;
//             if (end && now > end) return false;
//             if (start && now < start) return false;

//             const matchProduct = a.appliesTo?.products?.includes(product.id);

//             const productSeries = Array.isArray(product.seria)
//               ? product.seria
//               : typeof product.seria === "string" && product.seria !== ""
//                 ? [product.seria]
//                 : [];
//             const matchSeries = productSeries.some((ser) =>
//               a.appliesTo?.series?.includes(ser),
//             );

//             const productAuthors = Array.isArray(product.textAutor)
//               ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
//               : typeof product.textAutor === "string" &&
//                   product.textAutor !== ""
//                 ? [product.textAutor.split(" ")[0].trim()]
//                 : [];
//             const actionAuthors = Array.isArray(a.appliesTo?.authors)
//               ? a.appliesTo.authors.map((x) => (x || "").split(" ")[0].trim())
//               : [];
//             const matchAuthor = productAuthors.some((x) =>
//               actionAuthors.includes(x),
//             );

//             return matchProduct || matchSeries || matchAuthor;
//           });

//           if (matchedAction) actionDiscount = matchedAction.discountPercent;

//           let saleDiscount = null;
//           const matchedSale = sales.find((s) => {
//             const start = s.startDate ? new Date(s.startDate) : null;
//             const end = s.endDate ? new Date(s.endDate) : null;
//             if (end && now > end) return false;
//             if (start && now < start) return false;

//             const applies = s.appliesTo || {};
//             const matchProduct =
//               Array.isArray(applies.products) &&
//               applies.products.includes(product.id);

//             const productSeries =
//               Array.isArray(product.seria) && product.seria.length
//                 ? product.seria
//                 : typeof product.seria === "string" && product.seria !== ""
//                   ? [product.seria]
//                   : Array.isArray(product.series) && product.series.length
//                     ? product.series
//                     : typeof product.series === "string" &&
//                         product.series !== ""
//                       ? [product.series]
//                       : [];

//             const matchSeries =
//               Array.isArray(applies.series) &&
//               productSeries.some((ser) => applies.series.includes(ser));

//             const productAuthors = Array.isArray(product.textAutor)
//               ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
//               : typeof product.textAutor === "string" &&
//                   product.textAutor !== ""
//                 ? [product.textAutor.split(" ")[0].trim()]
//                 : [];
//             const saleAuthors = Array.isArray(applies.authors)
//               ? applies.authors.map((x) => (x || "").split(" ")[0].trim())
//               : [];
//             const matchAuthor = productAuthors.some((x) =>
//               saleAuthors.includes(x),
//             );

//             return matchProduct || matchSeries || matchAuthor;
//           });

//           if (matchedSale)
//             saleDiscount = Number(matchedSale.discountPercent) || 0;

//           return {
//             ...product,
//             uid: ci.uid,
//             quantity: ci.quantity,
//             actionDiscountPercent: actionDiscount,
//             saleDiscountPercent: saleDiscount,
//           };
//         })
//         .filter(Boolean);

//       bundles.forEach((b) => {
//         const ids = (b.products || []).map((p) => (p.productId || "").trim());
//         const inCart = withFlags.filter((p) =>
//           ids.includes((p.id || "").trim()),
//         );
//         if (inCart.length >= (b.products || []).length) {
//           inCart.forEach((item) => {
//             const matchBundleItem = (b.products || []).find(
//               (p) => (p.productId || "").trim() === (item.id || "").trim(),
//             );
//             if (matchBundleItem?.discount)
//               item.actionDiscountPercent = matchBundleItem.discount;
//           });
//         }
//       });

//       setCartProducts(withFlags);
//     };

//     fetchProducts();
//   }, []);

//   const writeCartToLS = (items) => {
//     localStorage.setItem("cart", JSON.stringify(items));
//   };

//   const handleQuantityChange = (uidItem, quantity) => {
//     setCartProducts((prev) =>
//       (prev || []).map((p) => (p.uid === uidItem ? { ...p, quantity } : p)),
//     );

//     const cart = JSON.parse(localStorage.getItem("cart") || "[]");
//     const next = Array.isArray(cart)
//       ? cart.map((x) => (x.uid === uidItem ? { ...x, quantity } : x))
//       : [];
//     writeCartToLS(next);
//   };

//   const removeProduct = (uidItem) => {
//     setCartProducts((prev) => (prev || []).filter((p) => p.uid !== uidItem));

//     const cart = JSON.parse(localStorage.getItem("cart") || "[]");
//     const next = Array.isArray(cart)
//       ? cart.filter((x) => x.uid !== uidItem)
//       : [];
//     writeCartToLS(next);
//   };

//   /* ================== ELEPHANTS ================== */
//   const handleApplyelefant = async () => {
//     if (
//       !currentUs ||
//       !currentUs.elefant ||
//       parseInt(currentUs.elefant, 10) === 0
//     ) {
//       Swal.fire({
//         icon: "info",
//         title: "Увага",
//         text: "У вас немає доступних слонів для списання.",
//       });
//       return;
//     }

//     const elephantsUsed = await applyElefant(async (uidUpdate) => {
//       const userDocRef = doc(db, "users", uidUpdate);
//       await setDoc(userDocRef, { elefant: "0" }, { merge: true });
//       setCurrentUs((p) => ({ ...(p || {}), elefant: "0" }));
//     });

//     if (elephantsUsed === false) {
//       Swal.fire({ icon: "info", title: "Увага", text: "Слонів немає." });
//     } else {
//       Swal.fire({
//         icon: "success",
//         title: "Слони застосовані!",
//         text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
//       });
//     }
//   };

//   /* ================== VALIDATION ================== */
//   const validateForm = () => {
//     if (
//       !(name || "").trim() ||
//       !(surName || "").trim() ||
//       !(phone || "").trim()
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Заповніть: Ім'я, Прізвище, Телефон.",
//       });
//       return false;
//     }

//     if (
//       !selectedOption &&
//       (!(nameOtr || "").trim() ||
//         !(surNameOtr || "").trim() ||
//         !(phoneOtr || "").trim())
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Заповніть дані отримувача.",
//       });
//       return false;
//     }

//     if (!(cityName || "").trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Введіть місто доставки.",
//       });
//       return false;
//     }

//     if (selectedDeliveryMethod === "1" && !(selectedDepartment || "").trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Виберіть відділення Нової пошти.",
//       });
//       return false;
//     }

//     return true;
//   };

//   /* ================== PAY ================== */
//   const payParam = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       setLoadingPay(true);

//       const json = JSON.stringify(cartProducts || []);
//       const us = user?.uid || "";
//       const isSelfReceiver = selectedOption === "Доставка";

//       const finalNameOtr = isSelfReceiver ? name : nameOtr;
//       const finalSurNameOtr = isSelfReceiver ? surName : surNameOtr;
//       const finalPhoneOtr = isSelfReceiver ? phone : phoneOtr;
//       const orderPayload = {
//         uid,
//         choice: json,
//         totalPrice,
//         finishPrice: newFinValue,
//         phone,
//         name,
//         surName,
//         discount: discountInHok,

//         nameOtr,
//         surNameOtr,
//         phoneOtr,

//         isNewBuyer,
//         cityName,
//         selectedDepartment,

//         pay: paymentMethod, // "card" | "invoice"
//         paymentMethod,
//         paymentStatus: paymentMethod === "card" ? "pending" : "invoice_pending",
//         paymentProvider: paymentMethod === "card" ? "liqpay" : "invoice",

//         user: us,
//         status: "Очікує підтвердження",
//         createdAt: serverTimestamp(),
//         userCategory: "Бізнес-партнер",
//       };

//       // 1) створюємо замовлення
//       await setDoc(doc(db, "orders", uid), orderPayload);

//       // 2) якщо рахунок — генеруємо рахунок на сервері
//       if (paymentMethod === "invoice") {
//         const inv = await startInvoiceCreate(uid); // { invoiceUrl, invoiceNumber }

//         localStorage.removeItem("cart");

//         await Swal.fire({
//           icon: "success",
//           title: "Рахунок сформовано",
//           html: inv?.invoiceUrl
//             ? `Номер: <b>${inv.invoiceNumber || "-"}</b><br/>
//        Дата: <b>${inv.invoiceDate || "-"}</b><br/>
//        <a href="${inv.invoiceUrl}" target="_blank" rel="noreferrer">
//          Відкрити Excel рахунок (.xlsx)
//        </a>`
//             : "Рахунок сформовано і прикріплено до замовлення.",
//         });

//         setLoadingPay(false);
//         return;
//       }

//       // 3) якщо карта — отримуємо data/signature і редіректимо на LiqPay
//       const lp = await startLiqPayCheckout(uid); // { data, signature }
//       if (!lp?.data || !lp?.signature)
//         throw new Error("LiqPay: немає data/signature");

//       localStorage.removeItem("cart");

//       redirectToLiqPay({ data: lp.data, signature: lp.signature });
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Не вдалося створити оплату/рахунок. Спробуйте пізніше.",
//       });
//       setLoadingPay(false);
//     }
//   };

//   /* ================== UI HANDLERS ================== */
//   const handleNewBuyerClick = () => setIsNewBuyer(true);
//   const handleAlwaysBuyerClick = () => setIsNewBuyer(false);

//   const handleOptionClick = (opt) => {
//     if (selectedOption === opt) {
//       setSelectedOption(null);
//       setWhoCust(true);
//     } else {
//       setSelectedOption(opt);
//       setWhoCust(false);
//     }
//   };

//   /* ================== RENDER ================== */
//   return (
//     <>
//       <div className={css.blueHeaderOrder}>
//         <div className={css.blueHeaderOrderEnter}>
//           <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
//         </div>
//       </div>

//       <div className={css.wrapCenterOrder}>
//         <div className={css.wrapCenterOrderSmall}>
//           <div className={css.firstBlockWrap}>
//             {!currentUs && (
//               <div className={css.newUserOrNoWrap}>
//                 <div
//                   className={`${css.newAlwaysBayer} ${isNewBuyer ? css.newBayer : ""}`}
//                   onClick={handleNewBuyerClick}
//                 >
//                   Я новий покупець
//                 </div>
//                 <div
//                   className={`${css.newAlwaysBayer} ${!isNewBuyer ? css.newBayer : ""}`}
//                   onClick={handleAlwaysBuyerClick}
//                 >
//                   Я постійний покупець
//                 </div>
//               </div>
//             )}

//             {!user && (
//               <p className={css.registerToOrder}>
//                 <span
//                   onClick={() => setLogin(true)}
//                   className={css.registerToOrderSpan}
//                 >
//                   ЗАРЕЄСТРУВАТИСЬ
//                 </span>{" "}
//                 для відслідковування замовлення
//               </p>
//             )}

//             <p className={css.labelMi}>Особисті дані</p>
//             <div className={css.wrapUserData}>
//               <input
//                 className={css.inputBig}
//                 type="text"
//                 placeholder="Ім'я"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//               />
//               <input
//                 className={css.inputBig}
//                 type="text"
//                 placeholder="Прізвище"
//                 value={surName}
//                 onChange={(e) => setSurName(e.target.value)}
//               />
//               <input
//                 className={css.inputBig}
//                 type="tel"
//                 placeholder="Телефон"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//                 required
//               />
//             </div>

//             <div className={css.deliveryChoisWrap}>
//               <div
//                 className={css.choisWrap}
//                 onClick={() => handleOptionClick("Доставка")}
//               >
//                 <div className={css.choisWi}>
//                   {selectedOption === "Доставка" && <div className={css.wi} />}
//                 </div>
//                 <p className={css.choisP}>Я отримувач</p>
//               </div>
//             </div>

//             <p className={css.labelMi}>Спосіб оплати</p>
//             <div className={css.deliveryChoisWrap}>
//               <div
//                 className={css.choisWrap}
//                 onClick={() => handlePaymentMethodClick("invoice")}
//               >
//                 <div className={css.choisWi}>
//                   {paymentMethod === "invoice" && <div className={css.wi} />}
//                 </div>
//                 <p className={css.choisP}>Оплата по рахунку</p>
//               </div>

//               <div
//                 className={css.choisWrap}
//                 onClick={() => handlePaymentMethodClick("card")}
//               >
//                 <div className={css.choisWi}>
//                   {paymentMethod === "card" && <div className={css.wi} />}
//                 </div>
//                 <p className={css.choisP}>Оплата картою</p>
//               </div>
//             </div>

//             {choisDostavka && (
//               <div className={css.wrapUserData}>
//                 {isBusinessPartner && (
//                   <div style={{ marginBottom: 12, width: "100%" }}>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         gap: 40,
//                       }}
//                     >
//                       <p className={css.choisP}>Збережені адреси</p>

//                       <button
//                         type="button"
//                         onClick={() => setBizAddrOpen((v) => !v)}
//                         style={{
//                           padding: "8px 12px",
//                           borderRadius: 0,
//                           border: "3px solid #3fac8c",
//                           background: "#fff",
//                           cursor: "pointer",
//                           fontWeight: 600,
//                           color: "#758391",
//                         }}
//                         disabled={bizAddrLoading}
//                       >
//                         {bizAddrLoading
//                           ? "Завантаження…"
//                           : bizAddrOpen
//                             ? "Закрити"
//                             : "Вибрати адресу"}
//                       </button>
//                     </div>

//                     {bizAddrOpen && (
//                       <div
//                         style={{
//                           marginTop: 10,
//                           border: "1px solid #eee",
//                           borderRadius: 12,
//                           overflow: "hidden",
//                           maxHeight: 260,
//                           overflowY: "auto",
//                           background: "#fff",
//                         }}
//                       >
//                         {bizAddresses.length === 0 ? (
//                           <div style={{ padding: 10, color: "#777" }}>
//                             Адрес немає
//                           </div>
//                         ) : (
//                           bizAddresses.map((a) => (
//                             <div
//                               key={a.id}
//                               style={{
//                                 display: "grid",
//                                 gridTemplateColumns:
//                                   "1.2fr 0.9fr 1.2fr 1.8fr auto",
//                                 gap: 10,
//                                 alignItems: "center",
//                                 padding: 10,
//                                 borderTop: "1px solid #f2f2f2",
//                                 fontSize: 14,
//                               }}
//                             >
//                               <div>{a.fio}</div>
//                               <div>{a.phone}</div>
//                               <div>
//                                 {a.city}
//                                 {a.area ? `, ${a.area}` : ""}
//                               </div>
//                               <div>{a.npWarehouse}</div>

//                               <button
//                                 type="button"
//                                 onClick={() => applyBizAddress(a)}
//                                 style={{
//                                   padding: "8px 12px",
//                                   borderRadius: 0,
//                                   border: "3px solid #3fac8c",
//                                   background: "#fff",
//                                   cursor: "pointer",
//                                   fontWeight: 600,
//                                   color: "#758391",
//                                 }}
//                               >
//                                 Використати
//                               </button>
//                             </div>
//                           ))
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 )}

//                 <div className={css.chousBooksSelect}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedCountry}
//                     onChange={(e) => setSelectedCountry(e.target.value)}
//                   >
//                     <option className={css.customOpin} value="1">
//                       Україна
//                     </option>
//                   </select>
//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>

//                 <div className={css.chousBooksSelect}>
//                   <input
//                     className={css.inputSmallWrap}
//                     type="text"
//                     value={cityName}
//                     onChange={handleCityInputChange}
//                     placeholder="Місто"
//                     onFocus={() => setUlVisible(true)}
//                   />
//                   {ulVisible && Array.isArray(cities) && cities.length > 0 && (
//                     <ul className={css.ulWrapBigCity}>
//                       {cities.map((city, i) => (
//                         <li
//                           onClick={() => handleCityClick(city)}
//                           key={`${city.Ref || i}-${i}`}
//                           className={css.liInListSitu}
//                         >
//                           {city.SettlementTypeDescription
//                             ? `${city.SettlementTypeDescription}, `
//                             : ""}
//                           {city.Description}
//                           {city.AreaDescription
//                             ? `, ${city.AreaDescription}`
//                             : ""}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>

//                 <div className={css.chousBooksSelectBig}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedDeliveryMethod}
//                     onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
//                   >
//                     <option className={css.customOpin} value="1">
//                       Нова пошта
//                     </option>
//                   </select>
//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>

//                 <div className={css.chousBooksSelectBig}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedDepartment}
//                     onChange={(e) => setSelectedDepartment(e.target.value)}
//                     disabled={
//                       !selectedCity?.Ref || selectedDeliveryMethod !== "1"
//                     }
//                   >
//                     {selectedDepartment ? (
//                       <option value={selectedDepartment}>
//                         {selectedDepartment}
//                       </option>
//                     ) : (
//                       <option value="">Оберіть відділення</option>
//                     )}

//                     {Array.isArray(departments) && departments.length > 0 ? (
//                       departments.map((d, idx) => (
//                         <option
//                           key={`${d.Ref || idx}`}
//                           value={d?.Description || ""}
//                         >
//                           {d?.Description || "Відділення"}
//                         </option>
//                       ))
//                     ) : (
//                       <option value="" disabled>
//                         Відділень не знайдено
//                       </option>
//                     )}
//                   </select>

//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>
//               </div>
//             )}

//             {whoCust && (
//               <>
//                 <p className={css.labelMi}>Контактні дані отримувача</p>
//                 <div className={css.wrapUserData}>
//                   <input
//                     className={css.inputBig}
//                     type="text"
//                     placeholder="Ім'я"
//                     value={nameOtr}
//                     onChange={(e) => setNameOtr(e.target.value)}
//                   />
//                   <input
//                     className={css.inputBig}
//                     type="text"
//                     placeholder="Прізвище"
//                     value={surNameOtr}
//                     onChange={(e) => setSurNameOtr(e.target.value)}
//                   />
//                   <input
//                     className={css.inputBig}
//                     type="tel"
//                     placeholder="Телефон"
//                     value={phoneOtr}
//                     onChange={(e) => setPhoneOtr(e.target.value)}
//                     required
//                   />
//                 </div>
//               </>
//             )}

//             <button
//               type="submit"
//               className={css.orderConfirmation}
//               onClick={payParam}
//               disabled={loadingPay}
//             >
//               {loadingPay ? "Обробка..." : "Оформити замовлення"}
//             </button>
//           </div>

//           <div className={css.wrapProdForOrder}>
//             {cartProducts?.map((el, i) => (
//               <ProductInOrder
//                 key={i}
//                 el={el}
//                 removeProduct={removeProduct}
//                 handleQuantityChange={handleQuantityChange}
//               />
//             ))}

//             <div className={css.lineWrap} />
//             <p className={css.sumOrder}>Всього: {totalPrice} грн</p>
//             <p className={css.sumOrder}>Знижка: {discountInHok} %</p>
//             <p className={css.sumOrder}>
//               Оплата: {paymentMethod === "invoice" ? "По рахунку" : "Картою"}
//             </p>

//             <div className={css.discountWrapOrder}>
//               <p className={css.slonuInL}>
//                 Ви можете використати Ваші слони. Загальна кількість слонів{" "}
//                 <strong>{currentUs && currentUs.elefant}</strong>
//               </p>
//               <div className={css.promoButton} onClick={handleApplyelefant}>
//                 Застосувати
//               </div>
//             </div>

//             <p className={css.sum}>Сума: {newFinValue} грн</p>
//           </div>
//         </div>
//       </div>

//       {loadingPay && (
//         <div className={css.spinerWrap}>
//           <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
//         </div>
//       )}
//     </>
//   );
// };

// export default PartnerOrder;
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import css from "./order.module.css";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";

import logoForSlidef from "../../svg/logoForSlidef.svg";
import arrowImp from "../../img/arrowDownPick.png";

import { startInvoiceCreate, startLiqPayCheckout } from "./paymentApi";
import { redirectToLiqPay } from "./liqpayRedirect";

import ProductInOrder from "./productInOrder";
import { useCartCalculations } from "./useCartCalculations";

import {
  getDocs,
  getDoc,
  doc,
  setDoc,
  collection,
  serverTimestamp,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import { db } from "../../firebase";

/* ================== NP API ================== */
const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

/* ================== HELPERS ================== */
const toNumber = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

const trimStr = (v) => String(v ?? "").trim();

const normalizePhone = (v) => String(v ?? "").trim();

function splitFio(fio = "") {
  const parts = String(fio).trim().split(/\s+/).filter(Boolean);
  return {
    first: parts[0] || "",
    last: parts.slice(1).join(" ") || "",
  };
}

function getFinalUnitPrice(p) {
  const price = Number(p?.price) || 0;

  const hasFixedSale =
    p?.priceSale !== undefined && p?.priceSale !== null && p?.priceSale !== "";
  const hasSaleDiscount =
    p?.saleDiscountPercent && Number(p.saleDiscountPercent) > 0;
  const hasActionDiscount =
    p?.actionDiscountPercent && Number(p.actionDiscountPercent) > 0;
  const hasBundleDiscount =
    p?.bundleDiscountPercent && Number(p.bundleDiscountPercent) > 0;

  if (hasFixedSale) return Number(p.priceSale) || price;
  if (hasSaleDiscount)
    return Math.round(price - (price * Number(p.saleDiscountPercent)) / 100);
  if (hasActionDiscount)
    return Math.round(price - (price * Number(p.actionDiscountPercent)) / 100);
  if (hasBundleDiscount)
    return Math.round(price - (price * Number(p.bundleDiscountPercent)) / 100);

  return price;
}

function getInitialPayMethod(userDoc) {
  if (!userDoc) return "card";
  if (userDoc.payByInvoice === true) return "invoice";

  const raw =
    userDoc.preferredPaymentMethod ??
    userDoc.paymentMethod ??
    userDoc.payMethod ??
    userDoc.pay ??
    "";

  const v = String(raw).toLowerCase().trim();

  if (v.includes("рах") || v.includes("invoice") || v === "2") return "invoice";
  if (v.includes("карт") || v.includes("card") || v === "1") return "card";

  return "card";
}

async function npGetCitiesSimple(apiKey, q) {
  if (!apiKey || !trimStr(q)) return [];

  const body = {
    apiKey,
    modelName: "Address",
    calledMethod: "getCities",
    methodProperties: { FindByString: q },
  };

  const res = await fetch(NP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}

async function npGetWarehousesSimple(apiKey, cityRef) {
  if (!apiKey || !cityRef) return [];

  const body = {
    apiKey,
    modelName: "AddressGeneral",
    calledMethod: "getWarehouses",
    methodProperties: { CityRef: cityRef, Page: "1", Limit: "500" },
  };

  const res = await fetch(NP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}
function applyPercentDiscount(price, percent) {
  const p = Number(price) || 0;
  const d = Number(percent) || 0;
  if (p <= 0 || d <= 0) return p;
  return Math.round(p - (p * d) / 100);
}

function hasProductPromo(p) {
  const hasFixedSale =
    p?.priceSale !== undefined && p?.priceSale !== null && p?.priceSale !== "";

  const hasSaleDiscount = Number(p?.saleDiscountPercent || 0) > 0;
  const hasActionDiscount = Number(p?.actionDiscountPercent || 0) > 0;
  const hasBundleDiscount = Number(p?.bundleDiscountPercent || 0) > 0;

  return (
    hasFixedSale || hasSaleDiscount || hasActionDiscount || hasBundleDiscount
  );
}

function allocateDiscountByWeights(totalDiscount, weights) {
  const total = Math.max(0, Math.round(Number(totalDiscount) || 0));
  const safeWeights = (Array.isArray(weights) ? weights : []).map((w) =>
    Math.max(0, Math.round(Number(w) || 0)),
  );

  const sumWeights = safeWeights.reduce((a, b) => a + b, 0);

  if (!total || !safeWeights.length || !sumWeights) {
    return new Array(safeWeights.length).fill(0);
  }

  const raw = safeWeights.map((w) => (w * total) / sumWeights);
  const base = raw.map((x) => Math.floor(x));
  let remainder = total - base.reduce((a, b) => a + b, 0);

  const order = raw
    .map((x, i) => ({ i, frac: x - Math.floor(x) }))
    .sort((a, b) => b.frac - a.frac);

  let k = 0;
  while (remainder > 0 && order.length > 0) {
    base[order[k % order.length].i] += 1;
    remainder -= 1;
    k += 1;
  }

  return base;
}
function buildChoiceForOrder(
  cartProducts = [],
  {
    isBusinessPartner = false,
    discountPercent = 0,
    finalOrderTotal = null,
  } = {},
) {
  const prepared = (Array.isArray(cartProducts) ? cartProducts : []).map(
    (p) => {
      const qty = Math.max(1, toNumber(p?.quantity, 1));
      const basePrice = toNumber(p?.price, 0);

      // Ціна після акцій / sale / bundle, але ще БЕЗ партнерської знижки
      const promoUnitPrice = toNumber(getFinalUnitPrice(p), basePrice);
      const promoLineTotal = promoUnitPrice * qty;

      const hasPromo = hasProductPromo(p);

      // Партнерську знижку застосовуємо лише якщо товар НЕ акційний
      const unitAfterPartner =
        isBusinessPartner && !hasPromo && Number(discountPercent) > 0
          ? applyPercentDiscount(promoUnitPrice, discountPercent)
          : promoUnitPrice;

      const lineAfterPartner = unitAfterPartner * qty;

      return {
        uid: p?.uid || p?.id || "",
        id: p?.id || p?.uid || "",
        productId: p?.id || p?.uid || "",

        name: p?.bookName || p?.name || "Товар",
        bookName: p?.bookName || p?.name || "Товар",

        quantity: qty,

        basePrice,
        promoUnitPrice,
        promoLineTotal,
        unitAfterPartner,
        lineAfterPartner,
        hasPromo,

        article: p?.article || "",
        sku: p?.sku || p?.id || "",
        imageList: Array.isArray(p?.imageList) ? p.imageList : [],
        images: Array.isArray(p?.images) ? p.images : [],
        category: p?.category || "",
        textAutor: p?.textAutor || "",
        seria: p?.seria || p?.series || "",

        saleDiscountPercent: toNumber(p?.saleDiscountPercent, 0),
        actionDiscountPercent: toNumber(p?.actionDiscountPercent, 0),
        bundleDiscountPercent: toNumber(p?.bundleDiscountPercent, 0),
      };
    },
  );

  // Сума після товарних акцій + партнерської знижки
  const subtotalAfterPartner = prepared.reduce(
    (sum, item) => sum + item.lineAfterPartner,
    0,
  );

  // Якщо є ще додаткове зменшення загальної суми (наприклад "слони"),
  // розподіляємо різницю між позиціями пропорційно
  const targetTotal =
    Number.isFinite(Number(finalOrderTotal)) && Number(finalOrderTotal) >= 0
      ? Math.round(Number(finalOrderTotal))
      : subtotalAfterPartner;

  const extraOrderDiscount = Math.max(0, subtotalAfterPartner - targetTotal);

  const extraAllocations = allocateDiscountByWeights(
    extraOrderDiscount,
    prepared.map((item) => item.lineAfterPartner),
  );

  return prepared.map((item, idx) => {
    const qty = item.quantity;
    const productDiscountLine = Math.max(
      0,
      item.basePrice * qty - item.promoLineTotal,
    );

    const partnerDiscountLine = Math.max(
      0,
      item.promoLineTotal - item.lineAfterPartner,
    );

    const extraOrderDiscountLine = extraAllocations[idx] || 0;

    const finalLineTotal = Math.max(
      0,
      item.lineAfterPartner - extraOrderDiscountLine,
    );

    const finalUnitPrice =
      qty > 0 ? Number((finalLineTotal / qty).toFixed(2)) : 0;

    const totalDiscountLine =
      productDiscountLine + partnerDiscountLine + extraOrderDiscountLine;

    return {
      // ключі сумісності
      uid: item.uid,
      id: item.id,
      productId: item.productId,

      name: item.name,
      bookName: item.bookName,

      quantity: qty,

      // ГОЛОВНЕ:
      // price / finalPrice / unitPrice = реальна ціна покупки
      price: finalUnitPrice,
      finalPrice: finalUnitPrice,
      unitPrice: finalUnitPrice,
      purchasedUnitPrice: finalUnitPrice,

      // snapshot базової/промо ціни
      basePrice: item.basePrice,
      promoUnitPrice: item.promoUnitPrice,

      // реальна сума рядка
      lineTotal: finalLineTotal,
      promoLineTotal: item.promoLineTotal,

      // знижки
      productDiscountLine,
      partnerDiscountLine,
      extraOrderDiscountLine,
      totalDiscountLine,

      article: item.article,
      sku: item.sku,
      imageList: item.imageList,
      images: item.images,
      category: item.category,
      textAutor: item.textAutor,
      seria: item.seria,

      saleDiscountPercent: item.saleDiscountPercent,
      actionDiscountPercent: item.actionDiscountPercent,
      bundleDiscountPercent: item.bundleDiscountPercent,
    };
  });
}

function getClientDateMeta() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");

  const yyyy = now.getFullYear();
  const mm = pad(now.getMonth() + 1);
  const dd = pad(now.getDate());
  const hh = pad(now.getHours());
  const mi = pad(now.getMinutes());
  const ss = pad(now.getSeconds());

  return {
    createdAtClient: now.getTime(), // числовий timestamp для сортування
    createdAtISO: now.toISOString(), // ISO
    createdDateKey: `${yyyy}-${mm}-${dd}`, // для фільтрації/групування
    createdTimeKey: `${hh}:${mi}:${ss}`,
    createdAtDisplay: `${dd}.${mm}.${yyyy} ${hh}:${mi}`,
  };
}

/* ================== COMPONENT ================== */
const PartnerOrder = ({ setLogin, user, discountInHok = 0, realUser }) => {
  const uid = useMemo(() => uuidv4(), []);

  /* ===== profile ===== */
  const [currentUs, setCurrentUs] = useState(null);

  /* ===== loaders ===== */
  const [loadingPay, setLoadingPay] = useState(false);

  /* ===== buyer main data ===== */
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [phone, setPhone] = useState("");

  /* ===== receiver data ===== */
  const [nameOtr, setNameOtr] = useState("");
  const [surNameOtr, setSurNameOtr] = useState("");
  const [phoneOtr, setPhoneOtr] = useState("");

  /* ===== ui toggles ===== */
  const [isNewBuyer, setIsNewBuyer] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null); // "Доставка" == "Я отримувач"

  /* ===== PAYMENT METHOD ===== */
  const [paymentMethod, setPaymentMethod] = useState("card"); // "invoice" | "card"
  const paymentInitRef = useRef(false);

  /* ===== NP ===== */
  const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("1"); // UA
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("1"); // NP

  const [cityName, setCityName] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [ulVisible, setUlVisible] = useState(false);

  const cityDebounceRef = useRef(null);

  /* ===== business addresses ===== */
  const [bizAddresses, setBizAddresses] = useState([]);
  const [bizAddrOpen, setBizAddrOpen] = useState(false);
  const [bizAddrLoading, setBizAddrLoading] = useState(false);

  /* ===== cart ===== */
  const [cartProducts, setCartProducts] = useState([]);

  const isBusinessPartner =
    (realUser?.category || currentUs?.category) === "Бізнес-партнер";

  const isSelfReceiver = selectedOption === "Доставка"; // ваша поточна логіка
  const showReceiverFields = !isSelfReceiver;

  const { totalPrice, newFinValue, applyElefant } = useCartCalculations({
    cartProducts,
    discountInHok,
    currentUser: currentUs,
  });

  /* ================== LOAD NP KEY ================== */
  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        const snap = await getDoc(doc(db, "novapost", "novaPoshtaData"));
        if (isMounted && snap.exists()) {
          setNovaPoshtaKey(snap.data()?.key || "");
        }
      } catch (e) {
        console.error("NP key load error:", e);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  /* ================== LOAD REAL USER (profile) ================== */
  useEffect(() => {
    let isMounted = true;

    const fetchCurrentUser = async () => {
      if (!user?.uid) return;

      if (realUser) {
        if (isMounted) setCurrentUs(realUser);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (isMounted && snap.exists()) {
          setCurrentUs({ uid: user.uid, ...snap.data() });
        }
      } catch (e) {
        console.error("User doc load error:", e);
      }
    };

    fetchCurrentUser();

    return () => {
      isMounted = false;
    };
  }, [user?.uid, realUser]);

  /* ================== PREFILL FROM PROFILE ================== */
  useEffect(() => {
    if (!currentUs) return;

    if (currentUs.displayName) {
      const parts = String(currentUs.displayName).trim().split(/\s+/);
      setName(parts[0] || "");
      setSurName(parts.slice(1).join(" ") || "");
    }

    if (currentUs.phone) setPhone(String(currentUs.phone));

    if (currentUs?.deliveryCity?.Ref) {
      setSelectedCity(currentUs.deliveryCity);
      setCityName(currentUs.deliveryCity?.Description || "");
      setSelectedDepartment(currentUs.deliveryDepartment || "");
    }

    if (!paymentInitRef.current) {
      setPaymentMethod(getInitialPayMethod(currentUs));
      paymentInitRef.current = true;
    }
  }, [currentUs]);

  /* ================== LOAD BUSINESS ADDRESSES ================== */
  useEffect(() => {
    let isMounted = true;

    const loadBizAddresses = async () => {
      if (!user?.uid) return;
      if (!isBusinessPartner) return;

      setBizAddrLoading(true);

      try {
        const ref = collection(db, `users/${user.uid}/deliveryAddresses`);
        const qx = query(ref, orderBy("createdAt", "desc"), limit(50));
        const snap = await getDocs(qx);
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        if (isMounted) setBizAddresses(list);
      } catch (e) {
        console.error("Помилка завантаження бізнес-адрес:", e);
        if (isMounted) setBizAddresses([]);
      } finally {
        if (isMounted) setBizAddrLoading(false);
      }
    };

    loadBizAddresses();

    return () => {
      isMounted = false;
    };
  }, [user?.uid, isBusinessPartner]);

  const applyBizAddress = useCallback((addr) => {
    if (!addr) return;

    // Адреса для отримувача => відкриваємо блок отримувача
    setSelectedOption(null);

    const { first, last } = splitFio(addr.fio || "");
    setNameOtr(first);
    setSurNameOtr(last);
    setPhoneOtr(String(addr.phone || ""));

    const city = trimStr(addr.city);
    const area = trimStr(addr.area);
    const dept = trimStr(addr.npWarehouse);

    setCityName(city);
    setSelectedDepartment(dept);
    setUlVisible(false);

    if (addr.cityRef) {
      setSelectedCity({
        Ref: addr.cityRef,
        Description: city,
        AreaDescription: area,
      });
    } else {
      setSelectedCity(null);
    }

    Swal.fire({
      icon: "success",
      title: "Адресу підставлено",
      timer: 900,
      showConfirmButton: false,
    });
  }, []);

  /* ================== LOAD WAREHOUSES ================== */
  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!novaPoshtaKey || !selectedCity?.Ref) {
        setDepartments([]);
        return;
      }

      try {
        const list = await npGetWarehousesSimple(
          novaPoshtaKey,
          selectedCity.Ref,
        );
        if (!cancelled) setDepartments(list || []);
      } catch (e) {
        console.error("NP warehouses load error:", e);
        if (!cancelled) setDepartments([]);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [novaPoshtaKey, selectedCity?.Ref]);

  /* ================== CITY SEARCH (debounce) ================== */
  const handleCityInputChange = useCallback(
    (e) => {
      const val = e.target.value;
      setCityName(val);
      setUlVisible(true);
      setSelectedCity(null);
      setSelectedDepartment("");

      if (cityDebounceRef.current) clearTimeout(cityDebounceRef.current);

      cityDebounceRef.current = setTimeout(async () => {
        try {
          if (!novaPoshtaKey || !trimStr(val)) {
            setCities([]);
            return;
          }
          const list = await npGetCitiesSimple(novaPoshtaKey, val);
          setCities(list || []);
        } catch (err) {
          console.error("NP cities load error:", err);
          setCities([]);
        }
      }, 250);
    },
    [novaPoshtaKey],
  );

  useEffect(() => {
    return () => {
      if (cityDebounceRef.current) clearTimeout(cityDebounceRef.current);
    };
  }, []);

  const handleCityClick = useCallback((city) => {
    setSelectedCity(city || null);
    setCityName(city?.Description || "");
    setUlVisible(false);
    setSelectedDepartment("");
  }, []);

  /* ================== CART LOAD ================== */
  useEffect(() => {
    let isMounted = true;

    const fetchProducts = async () => {
      try {
        const cartLocal = JSON.parse(localStorage.getItem("cart") || "[]");

        if (!Array.isArray(cartLocal) || cartLocal.length === 0) {
          if (isMounted) setCartProducts([]);
          return;
        }

        const [productsSnap, bundlesSnap, actionsSnap, salesSnap] =
          await Promise.all([
            getDocs(collection(db, "product")),
            getDocs(collection(db, "bundles")),
            getDocs(collection(db, "actions")),
            getDocs(collection(db, "sales")),
          ]);

        const productsList = productsSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        const bundles = bundlesSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        const actions = actionsSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        const sales = salesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

        const now = new Date();

        const withFlags = cartLocal
          .map((ci) => {
            const product = productsList.find((p) => p.id === ci.uid);
            if (!product) return null;

            let actionDiscount = null;
            const matchedAction = actions.find((a) => {
              const start = a.startDate ? new Date(a.startDate) : null;
              const end = a.endDate ? new Date(a.endDate) : null;
              if (end && now > end) return false;
              if (start && now < start) return false;

              const matchProduct = a.appliesTo?.products?.includes(product.id);

              const productSeries = Array.isArray(product.seria)
                ? product.seria
                : typeof product.seria === "string" && product.seria !== ""
                  ? [product.seria]
                  : [];
              const matchSeries = productSeries.some((ser) =>
                a.appliesTo?.series?.includes(ser),
              );

              const productAuthors = Array.isArray(product.textAutor)
                ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
                : typeof product.textAutor === "string" &&
                    product.textAutor !== ""
                  ? [product.textAutor.split(" ")[0].trim()]
                  : [];

              const actionAuthors = Array.isArray(a.appliesTo?.authors)
                ? a.appliesTo.authors.map((x) => (x || "").split(" ")[0].trim())
                : [];

              const matchAuthor = productAuthors.some((x) =>
                actionAuthors.includes(x),
              );

              return matchProduct || matchSeries || matchAuthor;
            });

            if (matchedAction) actionDiscount = matchedAction.discountPercent;

            let saleDiscount = null;
            const matchedSale = sales.find((s) => {
              const start = s.startDate ? new Date(s.startDate) : null;
              const end = s.endDate ? new Date(s.endDate) : null;
              if (end && now > end) return false;
              if (start && now < start) return false;

              const applies = s.appliesTo || {};
              const matchProduct =
                Array.isArray(applies.products) &&
                applies.products.includes(product.id);

              const productSeries =
                Array.isArray(product.seria) && product.seria.length
                  ? product.seria
                  : typeof product.seria === "string" && product.seria !== ""
                    ? [product.seria]
                    : Array.isArray(product.series) && product.series.length
                      ? product.series
                      : typeof product.series === "string" &&
                          product.series !== ""
                        ? [product.series]
                        : [];

              const matchSeries =
                Array.isArray(applies.series) &&
                productSeries.some((ser) => applies.series.includes(ser));

              const productAuthors = Array.isArray(product.textAutor)
                ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
                : typeof product.textAutor === "string" &&
                    product.textAutor !== ""
                  ? [product.textAutor.split(" ")[0].trim()]
                  : [];

              const saleAuthors = Array.isArray(applies.authors)
                ? applies.authors.map((x) => (x || "").split(" ")[0].trim())
                : [];

              const matchAuthor = productAuthors.some((x) =>
                saleAuthors.includes(x),
              );

              return matchProduct || matchSeries || matchAuthor;
            });

            if (matchedSale)
              saleDiscount = Number(matchedSale.discountPercent) || 0;

            return {
              ...product,
              uid: ci.uid,
              quantity: Math.max(1, toNumber(ci.quantity, 1)),
              actionDiscountPercent: actionDiscount,
              saleDiscountPercent: saleDiscount,
            };
          })
          .filter(Boolean);

        bundles.forEach((b) => {
          const ids = (b.products || []).map((p) => (p.productId || "").trim());
          const inCart = withFlags.filter((p) =>
            ids.includes((p.id || "").trim()),
          );

          if (inCart.length >= (b.products || []).length) {
            inCart.forEach((item) => {
              const matchBundleItem = (b.products || []).find(
                (p) => (p.productId || "").trim() === (item.id || "").trim(),
              );
              if (matchBundleItem?.discount) {
                item.actionDiscountPercent = matchBundleItem.discount;
              }
            });
          }
        });

        if (isMounted) setCartProducts(withFlags);
      } catch (e) {
        console.error("Cart load error:", e);
        if (isMounted) setCartProducts([]);
      }
    };

    fetchProducts();

    return () => {
      isMounted = false;
    };
  }, []);

  const writeCartToLS = useCallback((items) => {
    localStorage.setItem("cart", JSON.stringify(items));
  }, []);

  const handleQuantityChange = useCallback(
    (uidItem, quantity) => {
      const qty = Math.max(1, toNumber(quantity, 1));

      setCartProducts((prev) =>
        (prev || []).map((p) =>
          p.uid === uidItem ? { ...p, quantity: qty } : p,
        ),
      );

      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      const next = Array.isArray(cart)
        ? cart.map((x) => (x.uid === uidItem ? { ...x, quantity: qty } : x))
        : [];

      writeCartToLS(next);
    },
    [writeCartToLS],
  );

  const removeProduct = useCallback(
    (uidItem) => {
      setCartProducts((prev) => (prev || []).filter((p) => p.uid !== uidItem));

      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      const next = Array.isArray(cart)
        ? cart.filter((x) => x.uid !== uidItem)
        : [];

      writeCartToLS(next);
    },
    [writeCartToLS],
  );

  /* ================== ELEPHANTS ================== */
  const handleApplyelefant = useCallback(async () => {
    if (
      !currentUs ||
      !currentUs.elefant ||
      parseInt(currentUs.elefant, 10) === 0
    ) {
      Swal.fire({
        icon: "info",
        title: "Увага",
        text: "У вас немає доступних слонів для списання.",
      });
      return;
    }

    try {
      const elephantsUsed = await applyElefant(async (uidUpdate) => {
        const userDocRef = doc(db, "users", uidUpdate);
        await setDoc(userDocRef, { elefant: "0" }, { merge: true });
        setCurrentUs((p) => ({ ...(p || {}), elefant: "0" }));
      });

      if (elephantsUsed === false) {
        Swal.fire({ icon: "info", title: "Увага", text: "Слонів немає." });
      } else {
        Swal.fire({
          icon: "success",
          title: "Слони застосовані!",
          text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
        });
      }
    } catch (e) {
      console.error("Elefant apply error:", e);
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося застосувати слонів.",
      });
    }
  }, [applyElefant, currentUs]);

  /* ================== VALIDATION ================== */
  const validateForm = useCallback(() => {
    if ((cartProducts || []).length === 0) {
      Swal.fire({
        icon: "error",
        title: "Кошик порожній",
        text: "Додайте товари перед оформленням замовлення.",
      });
      return false;
    }

    if (!trimStr(name) || !trimStr(surName) || !trimStr(phone)) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть: Ім'я, Прізвище, Телефон.",
      });
      return false;
    }

    if (
      !isSelfReceiver &&
      (!trimStr(nameOtr) || !trimStr(surNameOtr) || !trimStr(phoneOtr))
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть дані отримувача.",
      });
      return false;
    }

    if (!trimStr(cityName)) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Введіть місто доставки.",
      });
      return false;
    }

    if (selectedDeliveryMethod === "1" && !trimStr(selectedDepartment)) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Виберіть відділення Нової пошти.",
      });
      return false;
    }

    return true;
  }, [
    cartProducts,
    cityName,
    isSelfReceiver,
    name,
    surName,
    phone,
    nameOtr,
    surNameOtr,
    phoneOtr,
    selectedDepartment,
    selectedDeliveryMethod,
  ]);

  /* ================== PAY ================== */
  const payParam = useCallback(
    async (e) => {
      e.preventDefault?.();

      if (loadingPay) return;
      if (!validateForm()) return;

      try {
        setLoadingPay(true);

        const us = user?.uid || "";

        const finalBuyer = {
          name: trimStr(name),
          surName: trimStr(surName),
          phone: normalizePhone(phone),
        };

        const finalReceiver = isSelfReceiver
          ? { ...finalBuyer }
          : {
              name: trimStr(nameOtr),
              surName: trimStr(surNameOtr),
              phone: normalizePhone(phoneOtr),
            };

        // const choicePrepared = buildChoiceForOrder(cartProducts);
        // const choiceJson = JSON.stringify(choicePrepared);

        // const safeTotalPrice = toNumber(totalPrice, 0);
        // const safeFinishPrice = toNumber(newFinValue, 0);
        // const safeDiscount = toNumber(discountInHok, 0);
        const safeTotalPrice = toNumber(totalPrice, 0);
        const safeFinishPrice = toNumber(newFinValue, 0);
        const safeDiscount = toNumber(discountInHok, 0);

        const choicePrepared = buildChoiceForOrder(cartProducts, {
          isBusinessPartner,
          discountPercent: safeDiscount,
          finalOrderTotal: safeFinishPrice,
        });

        const choiceJson = JSON.stringify(choicePrepared);
        const dateMeta = getClientDateMeta();

        const orderPayload = {
          /* ===== legacy / existing compatibility ===== */
          uid,
          choice: choiceJson,
          totalPrice: safeTotalPrice,
          finishPrice: safeFinishPrice,

          phone: finalBuyer.phone,
          name: finalBuyer.name,
          surName: finalBuyer.surName,
          discount: safeDiscount,

          nameOtr: finalReceiver.name,
          surNameOtr: finalReceiver.surName,
          phoneOtr: finalReceiver.phone,

          isNewBuyer,
          cityName: trimStr(cityName),
          selectedDepartment: trimStr(selectedDepartment),

          pay: paymentMethod, // legacy
          paymentMethod,
          paymentStatus:
            paymentMethod === "card" ? "pending" : "invoice_pending",
          paymentProvider: paymentMethod === "card" ? "liqpay" : "invoice",

          user: us, // legacy
          status: "Очікує підтвердження",
          createdAt: serverTimestamp(),
          userCategory: "Бізнес-партнер",

          /* ===== new structured fields ===== */
          orderId: uid,
          orderNumber: uid, // поки так; сервер може замінити на свій послідовний номер
          orderType: "partner",
          orderSource: "web",
          orderVersion: 2,

          createdAtClient: dateMeta.createdAtClient,
          createdAtISO: dateMeta.createdAtISO,
          createdDateKey: dateMeta.createdDateKey,
          createdTimeKey: dateMeta.createdTimeKey,
          createdAtDisplay: dateMeta.createdAtDisplay,
          updatedAt: serverTimestamp(),

          userId: us || null,
          userRef: us ? `users/${us}` : null,
          userSnapshot: {
            category:
              realUser?.category || currentUs?.category || "Бізнес-партнер",
            displayName: trimStr(
              currentUs?.displayName ||
                `${finalBuyer.name} ${finalBuyer.surName}`,
            ),
            phone: normalizePhone(currentUs?.phone || finalBuyer.phone),
            email: trimStr(currentUs?.email || ""),
          },

          buyer: {
            name: finalBuyer.name,
            surName: finalBuyer.surName,
            fullName: `${finalBuyer.name} ${finalBuyer.surName}`.trim(),
            phone: finalBuyer.phone,
          },

          receiver: {
            sameAsBuyer: isSelfReceiver,
            name: finalReceiver.name,
            surName: finalReceiver.surName,
            fullName: `${finalReceiver.name} ${finalReceiver.surName}`.trim(),
            phone: finalReceiver.phone,
          },

          delivery: {
            countryCode: selectedCountry === "1" ? "UA" : selectedCountry,
            countryName: selectedCountry === "1" ? "Україна" : "Україна",
            methodCode: selectedDeliveryMethod,
            methodName:
              selectedDeliveryMethod === "1" ? "Нова пошта" : "Нова пошта",

            cityName: trimStr(cityName),
            cityRef: selectedCity?.Ref || "",
            cityArea: selectedCity?.AreaDescription || "",
            cityRaw: selectedCity || null,

            warehouse: trimStr(selectedDepartment),
            warehouseRef:
              departments.find((d) => d?.Description === selectedDepartment)
                ?.Ref || "",
          },

          payment: {
            method: paymentMethod, // "card" | "invoice"
            provider: paymentMethod === "card" ? "liqpay" : "invoice",
            status: paymentMethod === "card" ? "pending" : "invoice_pending",
            isInvoiceRequested: paymentMethod === "invoice",
            isCardCheckoutRequested: paymentMethod === "card",
          },

          pricing: {
            totalPrice: safeTotalPrice,
            finishPrice: safeFinishPrice,
            discountPercent: safeDiscount,
            currency: "UAH",
            itemsCount: choicePrepared.reduce(
              (sum, item) => sum + toNumber(item.quantity, 0),
              0,
            ),
            positionsCount: choicePrepared.length,
          },

          // зручно для кабінету / звітів / відбору
          invoiceMeta:
            paymentMethod === "invoice"
              ? {
                  requested: true,
                  status: "pending_create",
                  fileType: "xlsx",
                }
              : {
                  requested: false,
                  status: null,
                  fileType: null,
                },
        };

        // 1) створюємо замовлення
        await setDoc(doc(db, "orders", uid), orderPayload);

        // 2) якщо рахунок — генеруємо рахунок на сервері (xlsx)
        if (paymentMethod === "invoice") {
          const inv = await startInvoiceCreate(uid);
          // очікуємо щось типу:
          // { ok, invoiceUrl, invoiceNumber, invoiceDate, invoiceId, fileType }

          localStorage.removeItem("cart");

          await Swal.fire({
            icon: "success",
            title: "Рахунок сформовано",
            html: inv?.invoiceUrl
              ? `Номер: <b>${inv.invoiceNumber || "-"}</b><br/>
                 Дата: <b>${inv.invoiceDate || "-"}</b><br/>
                 <a href="${inv.invoiceUrl}" target="_blank" rel="noreferrer">
                   Відкрити рахунок ${inv?.fileType ? `(.${inv.fileType})` : ""}
                 </a>`
              : "Рахунок сформовано і прикріплено до замовлення.",
          });

          setLoadingPay(false);
          return;
        }

        // 3) якщо карта — отримуємо data/signature і редіректимо на LiqPay
        const lp = await startLiqPayCheckout(uid); // { data, signature }
        if (!lp?.data || !lp?.signature) {
          throw new Error("LiqPay: немає data/signature");
        }

        localStorage.removeItem("cart");

        // після редіректу сторінка піде, setLoadingPay не обов'язковий
        redirectToLiqPay({ data: lp.data, signature: lp.signature });
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Помилка",
          text: "Не вдалося створити оплату/рахунок. Спробуйте пізніше.",
        });
        setLoadingPay(false);
      }
    },
    [
      loadingPay,
      validateForm,
      user?.uid,
      name,
      surName,
      phone,
      nameOtr,
      surNameOtr,
      phoneOtr,
      isSelfReceiver,
      cartProducts,
      totalPrice,
      newFinValue,
      discountInHok,
      uid,
      isNewBuyer,
      cityName,
      selectedDepartment,
      paymentMethod,
      realUser?.category,
      currentUs,
      selectedCountry,
      selectedDeliveryMethod,
      selectedCity,
      departments,
    ],
  );

  /* ================== UI HANDLERS ================== */
  const handleNewBuyerClick = () => setIsNewBuyer(true);
  const handleAlwaysBuyerClick = () => setIsNewBuyer(false);

  const handleOptionClick = (opt) => {
    // toggle
    setSelectedOption((prev) => (prev === opt ? null : opt));
  };

  const handlePaymentMethodClick = (method) => {
    setPaymentMethod(method);
  };

  /* ================== RENDER ================== */
  return (
    <>
      <div className={css.blueHeaderOrder}>
        <div className={css.blueHeaderOrderEnter}>
          <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
        </div>
      </div>

      <div className={css.wrapCenterOrder}>
        <div className={css.wrapCenterOrderSmall}>
          <div className={css.firstBlockWrap}>
            {!currentUs && (
              <div className={css.newUserOrNoWrap}>
                <div
                  className={`${css.newAlwaysBayer} ${isNewBuyer ? css.newBayer : ""}`}
                  onClick={handleNewBuyerClick}
                >
                  Я новий покупець
                </div>
                <div
                  className={`${css.newAlwaysBayer} ${!isNewBuyer ? css.newBayer : ""}`}
                  onClick={handleAlwaysBuyerClick}
                >
                  Я постійний покупець
                </div>
              </div>
            )}

            {!user && (
              <p className={css.registerToOrder}>
                <span
                  onClick={() => setLogin?.(true)}
                  className={css.registerToOrderSpan}
                >
                  ЗАРЕЄСТРУВАТИСЬ
                </span>{" "}
                для відслідковування замовлення
              </p>
            )}

            <p className={css.labelMi}>Особисті дані</p>
            <div className={css.wrapUserData}>
              <input
                className={css.inputBig}
                type="text"
                placeholder="Ім'я"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                className={css.inputBig}
                type="text"
                placeholder="Прізвище"
                value={surName}
                onChange={(e) => setSurName(e.target.value)}
              />
              <input
                className={css.inputBig}
                type="tel"
                placeholder="Телефон"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

            <div className={css.deliveryChoisWrap}>
              <div
                className={css.choisWrap}
                onClick={() => handleOptionClick("Доставка")}
              >
                <div className={css.choisWi}>
                  {isSelfReceiver && <div className={css.wi} />}
                </div>
                <p className={css.choisP}>Я отримувач</p>
              </div>
            </div>

            <p className={css.labelMi}>Спосіб оплати</p>
            <div className={css.deliveryChoisWrap}>
              <div
                className={css.choisWrap}
                onClick={() => handlePaymentMethodClick("invoice")}
              >
                <div className={css.choisWi}>
                  {paymentMethod === "invoice" && <div className={css.wi} />}
                </div>
                <p className={css.choisP}>Оплата по рахунку</p>
              </div>

              <div
                className={css.choisWrap}
                onClick={() => handlePaymentMethodClick("card")}
              >
                <div className={css.choisWi}>
                  {paymentMethod === "card" && <div className={css.wi} />}
                </div>
                <p className={css.choisP}>Оплата картою</p>
              </div>
            </div>

            {/* Блок доставки */}
            <div className={css.wrapUserData}>
              {isBusinessPartner && (
                <div style={{ marginBottom: 12, width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: 40,
                    }}
                  >
                    <p className={css.choisP}>Збережені адреси</p>

                    <button
                      type="button"
                      onClick={() => setBizAddrOpen((v) => !v)}
                      style={{
                        padding: "8px 12px",
                        borderRadius: 0,
                        border: "3px solid #3fac8c",
                        background: "#fff",
                        cursor: "pointer",
                        fontWeight: 600,
                        color: "#758391",
                      }}
                      disabled={bizAddrLoading}
                    >
                      {bizAddrLoading
                        ? "Завантаження…"
                        : bizAddrOpen
                          ? "Закрити"
                          : "Вибрати адресу"}
                    </button>
                  </div>

                  {bizAddrOpen && (
                    <div
                      style={{
                        marginTop: 10,
                        border: "1px solid #eee",
                        borderRadius: 12,
                        overflow: "hidden",
                        maxHeight: 260,
                        overflowY: "auto",
                        background: "#fff",
                      }}
                    >
                      {bizAddresses.length === 0 ? (
                        <div style={{ padding: 10, color: "#777" }}>
                          Адрес немає
                        </div>
                      ) : (
                        bizAddresses.map((a) => (
                          <div
                            key={a.id}
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "1.2fr 0.9fr 1.2fr 1.8fr auto",
                              gap: 10,
                              alignItems: "center",
                              padding: 10,
                              borderTop: "1px solid #f2f2f2",
                              fontSize: 14,
                            }}
                          >
                            <div>{a.fio}</div>
                            <div>{a.phone}</div>
                            <div>
                              {a.city}
                              {a.area ? `, ${a.area}` : ""}
                            </div>
                            <div>{a.npWarehouse}</div>

                            <button
                              type="button"
                              onClick={() => applyBizAddress(a)}
                              style={{
                                padding: "8px 12px",
                                borderRadius: 0,
                                border: "3px solid #3fac8c",
                                background: "#fff",
                                cursor: "pointer",
                                fontWeight: 600,
                                color: "#758391",
                              }}
                            >
                              Використати
                            </button>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className={css.chousBooksSelect}>
                <select
                  className={css.customSelect}
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                >
                  <option className={css.customOpin} value="1">
                    Україна
                  </option>
                </select>
                <img
                  src={arrowImp}
                  className={css.customArrowSelect}
                  alt="Arrow"
                />
              </div>

              <div className={css.chousBooksSelect}>
                <input
                  className={css.inputSmallWrap}
                  type="text"
                  value={cityName}
                  onChange={handleCityInputChange}
                  placeholder="Місто"
                  onFocus={() => setUlVisible(true)}
                />
                {ulVisible && Array.isArray(cities) && cities.length > 0 && (
                  <ul className={css.ulWrapBigCity}>
                    {cities.map((city, i) => (
                      <li
                        onClick={() => handleCityClick(city)}
                        key={`${city.Ref || i}-${i}`}
                        className={css.liInListSitu}
                      >
                        {city.SettlementTypeDescription
                          ? `${city.SettlementTypeDescription}, `
                          : ""}
                        {city.Description}
                        {city.AreaDescription
                          ? `, ${city.AreaDescription}`
                          : ""}
                      </li>
                    ))}
                  </ul>
                )}
                <img
                  src={arrowImp}
                  className={css.customArrowSelect}
                  alt="Arrow"
                />
              </div>

              <div className={css.chousBooksSelectBig}>
                <select
                  className={css.customSelect}
                  value={selectedDeliveryMethod}
                  onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
                >
                  <option className={css.customOpin} value="1">
                    Нова пошта
                  </option>
                </select>
                <img
                  src={arrowImp}
                  className={css.customArrowSelect}
                  alt="Arrow"
                />
              </div>

              <div className={css.chousBooksSelectBig}>
                <select
                  className={css.customSelect}
                  value={selectedDepartment}
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                  disabled={
                    !selectedCity?.Ref || selectedDeliveryMethod !== "1"
                  }
                >
                  {selectedDepartment ? (
                    <option value={selectedDepartment}>
                      {selectedDepartment}
                    </option>
                  ) : (
                    <option value="">Оберіть відділення</option>
                  )}

                  {Array.isArray(departments) && departments.length > 0 ? (
                    departments.map((d, idx) => (
                      <option
                        key={`${d.Ref || idx}`}
                        value={d?.Description || ""}
                      >
                        {d?.Description || "Відділення"}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      Відділень не знайдено
                    </option>
                  )}
                </select>

                <img
                  src={arrowImp}
                  className={css.customArrowSelect}
                  alt="Arrow"
                />
              </div>
            </div>

            {showReceiverFields && (
              <>
                <p className={css.labelMi}>Контактні дані отримувача</p>
                <div className={css.wrapUserData}>
                  <input
                    className={css.inputBig}
                    type="text"
                    placeholder="Ім'я"
                    value={nameOtr}
                    onChange={(e) => setNameOtr(e.target.value)}
                  />
                  <input
                    className={css.inputBig}
                    type="text"
                    placeholder="Прізвище"
                    value={surNameOtr}
                    onChange={(e) => setSurNameOtr(e.target.value)}
                  />
                  <input
                    className={css.inputBig}
                    type="tel"
                    placeholder="Телефон"
                    value={phoneOtr}
                    onChange={(e) => setPhoneOtr(e.target.value)}
                    required
                  />
                </div>
              </>
            )}

            <button
              type="submit"
              className={css.orderConfirmation}
              onClick={payParam}
              disabled={loadingPay}
            >
              {loadingPay ? "Обробка..." : "Оформити замовлення"}
            </button>
          </div>

          <div className={css.wrapProdForOrder}>
            {cartProducts?.map((el, i) => (
              <ProductInOrder
                key={el?.uid || el?.id || i}
                el={el}
                removeProduct={removeProduct}
                handleQuantityChange={handleQuantityChange}
              />
            ))}

            <div className={css.lineWrap} />
            <p className={css.sumOrder}>
              Всього: {toNumber(totalPrice, 0)} грн
            </p>
            <p className={css.sumOrder}>
              Знижка: {toNumber(discountInHok, 0)} %
            </p>
            <p className={css.sumOrder}>
              Оплата: {paymentMethod === "invoice" ? "По рахунку" : "Картою"}
            </p>

            <div className={css.discountWrapOrder}>
              <p className={css.slonuInL}>
                Ви можете використати Ваші слони. Загальна кількість слонів{" "}
                <strong>{currentUs?.elefant || 0}</strong>
              </p>
              <div className={css.promoButton} onClick={handleApplyelefant}>
                Застосувати
              </div>
            </div>

            <p className={css.sum}>Сума: {toNumber(newFinValue, 0)} грн</p>
          </div>
        </div>
      </div>

      {loadingPay && (
        <div className={css.spinerWrap}>
          <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
        </div>
      )}
    </>
  );
};

export default PartnerOrder;
